// Config init...
var _config = _config || {};
var _cfg = _config || {};

var isRtlPage = _config.isRtlPage;

var cls = {
    log: function (_output) {
        if (app.debug) {
            console.log.apply(this, arguments);
        }
    },
    warn: function () {
        if (app.debug) {
            console.warn.apply(this, arguments);
        }
    }
};

window.app || (window.app = {
    debug: false
});
app.modules || (app.modules = {});

app.modules.ajaxInclude = (function () {
    function ajaxIncludeCallback() {
        var includedContainer = $(this).next();

        if ($(this).is('[data-target]')) {
            var targetContainer = $($(this).data('target'));
            if (targetContainer.length > 0) {
                includedContainer = targetContainer;
            }
        }

        app.initModules(includedContainer);
        $(this).off('ajaxInclude', ajaxIncludeCallback);

        if (_config && _config['debug']) {
            console.warn('ajax included: ', includedContainer);
        }
    }

    return function ($scope) {
        var ajaxIncludeElements = $scope.find('.js-ajaxInclude');

        ajaxIncludeElements.on('ajaxInclude', function () {
            if (window.picturefillCFG) {
                picturefill();
            }
        });

        var ajaxIncludeOptions = {
            device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
        };

        ajaxIncludeElements.on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude(ajaxIncludeOptions);

        ajaxIncludeElements.filter('[data-interaction=click]').on('click', function () {
            $(this).removeAttr('data-interaction');
            $(this).on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude(ajaxIncludeOptions);
        });

    };

}());

app.recentlyViewed = function () {
    var recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    var productId = _config.productid;

    if (productId) {
        if (recentlyViewedProducts.indexOf(productId) > -1) {
            //console.log('if');
        } else {
            recentlyViewedProducts.unshift(productId);

            if (recentlyViewedProducts.length > 5) {
                recentlyViewedProducts.pop();
            }
        }

        localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProducts));
    }
};

app.modules.recentlyViewedSlider = function ($scope) {
    var $slider = $scope.find('.js-recently-viewed-slider');
    var url = _config.recentlyViewedUrl;
    var recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    var currentId = _config.productid;

    if ($slider.length) {
        var mappedCategoryIds = $slider.data('mapped-categories');

        //check if currentId is in recentlyViewedProducts
        if (recentlyViewedProducts.indexOf(currentId) > -1) {
            //remove currentId from recentlyViewedProducts
            recentlyViewedProducts.splice(recentlyViewedProducts.indexOf(currentId), 1);

        } else {
            //remove last item from recentlyViewedProducts
            if (recentlyViewedProducts.length > 4) {
                recentlyViewedProducts.pop();
            }
        }

        $.ajax(url, {
            data: {
                "productid" : encodeURIComponent(JSON.stringify(recentlyViewedProducts)),
                "categories": encodeURIComponent(mappedCategoryIds)
            },
            method: "GET"
        }).done(function (data) {
            if (data.success == true) {
                $slider.html(data.html);
                app.initModules($slider);
            }
        });
    }
}

app.modules.unitToggle = function () {
    var $unitToggles = $('.js-unit-toggle');
    var $metricItems = $('.js-unit-toggle__metric');
    var $imperialItems = $('.js-unit-toggle__imperial');
    var $imperialTab = $('.js-unit-tab__imperial');
    var $metricTab = $('.js-unit-tab__metric');
    var $imperialCollapse = $('.js-unit-collapse__imperial');
    var $metricCollapse = $('.js-unit-collapse__metric');

    var unit = localStorage.getItem("unit");

    function metric() {
        $metricItems.each(function () {
            $(this).removeClass('hidden');
        });
        $imperialItems.each(function () {
            $(this).addClass('hidden');
        });
        if (matchMedia('(max-width: 767px)').matches) {
            if ($metricCollapse && $metricCollapse.length) {
                $('.collapse').collapse('hide');
                $metricCollapse.collapse('show');
            }
        } else {
            if ($metricTab && $metricTab.length) {
                $metricTab.tab('show');
            }
        }
        $unitToggles.addClass('unit-toggle--metric-active');
    }

    function imperial() {
        $metricItems.each(function () {
            $(this).addClass('hidden');
        });
        $imperialItems.each(function () {
            $(this).removeClass('hidden');
        });
        if (matchMedia('(max-width: 767px)').matches) {
            if ($imperialCollapse && $imperialCollapse.length) {
                $('.collapse').collapse('hide');
                $imperialCollapse.collapse('show');
            }
        } else {
            if ($imperialTab && $imperialTab.length) {
                $imperialTab.tab('show');
            }
        }
        $unitToggles.removeClass('unit-toggle--metric-active');
    }


    if ($unitToggles && $unitToggles.length) {
        if (unit == 'metric') {
            metric();
        }

        if (unit == 'imperial') {
            imperial();
        }

        $unitToggles.each(function () {
            var $unitToggle = $(this);
            $unitToggle.on('click', function (e) {
                localStorage.removeItem("unit");

                e.preventDefault();
                e.stopImmediatePropagation();
                if ($(this).hasClass('unit-toggle--metric-active')) {
                    localStorage.setItem("unit", "imperial");
                    imperial();
                } else {
                    localStorage.setItem("unit", "metric");
                    metric();
                }
            });
        });
    }
}

app.modules.trackGTM = function ($scope) {
    $scope.find('.gtm-track-click').on('click', function (evt) {
        var category = $(this).data('event-category'),
            action = $(this).data('event-action'),
            $target = $(evt.target),
            label = $target.data('event-label'),
            eventName = $(this).data('event-name'),
            elementName = $(this).data('event-element-name'),
            url = $(this).attr('href'),
            component = $(this).data('event-component');

        if(!eventName){
            eventName = 'GAEvent';
        }

        dataLayer.push({
            'event': eventName,
            'eventCategory': (category ? category : undefined),
            'eventAction': (action ? action : undefined),
            'eventLabel': (label ? label : undefined),
            'component' : component,
            'clickURL' : (url ? url : undefined),
            'elementName' : elementName
        });

    });
};

app.modules.phoneBtn = function ($scope) {
    $scope.find('.js-phone-btn').on('click', function (evt) {
        evt.preventDefault();
        var phoneNumber = $(this).attr('data-phone-nr');

        $(this).text(phoneNumber);
        $(this).removeClass('btn-primary');
        $(this).addClass('btn-primary-border');
    });
};

app.modules.trackCallToActionGTM = function ($scope) {
    $scope.find('.gtm-track-cta-click').on('click', function (evt) {
        //remove item component from session storage
        sessionStorage.removeItem('component');

        var parentContainer = $(this).data('event-cta-parent-container'),
            elementPosition = $(this).data('event-cta-position'),
            target = $(this).data('event-cta-target'),
            text = $(this).data('event-cta-text'),
            component = $(this).data('event-component'),
            url = $(this).data('event-cta-url');

        //safe component to session storage, item is needed for tracking in modal
        sessionStorage.setItem('component', component);

        /*
        var obj = {
            'event': 'ctaAreaClick',
            'component': component,
            'ctaAreaClick': {
                'parentContainer': parentContainer,
                'elementPosition': elementPosition,
                'itemTargetType': target,
                'itemText': text,
                'itemUrl': ((target == 'modal') ? undefined : url)
            }
        };
        */

        var ctaAreaClickEvent = {
            'event': 'ctaAreaClick',
            'component': component,
            'ctaAreaClick': {
                'parentContainer': parentContainer,
                'elementPosition': elementPosition,
                'itemTargetType': target,
                'itemText': text,
                'itemUrl': ((target == 'modal') ? undefined : url)
            }
        };

        //console.log(ctaAreaClickEvent);

        dataLayer.push(ctaAreaClickEvent);

    });
};

app.modules.trackDownloads = function ($scope) {
    $scope.find('.gtm-track-downloads').on('click', function (evt) {
        var text = $(this).find('.download-teaser__headline').text(),
            url = $(this).find('.download-teaser__body__detail__download').attr('data-gtm-fullpath'),
            type = $(this).find('.download-teaser__body__detail__download').attr('data-gtm-type'),
            id = $(this).find('.download-teaser__body__detail__download').attr('data-gtm-id');

        if (window.dataLayer) {
            dataLayer.push({
                event: "fileDownload",
                component: "download teaser",
                element: "document",
                elementName: "download",
                elementType: type,
                clickUrl: encodeURI(window.location.protocol + '//' + window.location.hostname + url),
                contentName: text,
                position: "",
                elementId: id
            });
        }
    });
};

app.modules.trackDiagrams = function ($scope) {
    $scope.find('.gtm-track-diagram').on('click', function (evt) {
        var event = $(this).attr("data-gtm-event"),
            element = $(this).attr("data-gtm-element"),
            elementname = $(this).attr("data-gtm-elementname"),
            type = $(this).attr('data-gtm-type'),
            clickurl = $(this).attr('data-gtm-clickurl'),
            contentname = $(this).closest('.diagram-teaser').find('.diagram-teaser__title').text(),
            id = $(this).attr('data-gtm-id');

        if (window.dataLayer) {
            dataLayer.push({
                event: event,
                component: "diagram teaser",
                element: element,
                elementName: elementname,
                elementType: type,
                clickUrl: clickurl,
                contentName: contentname,
                position: "",
                elementId: id
            });
        }
    });
};

app.modules.isClickable = (function () {
    function isClickable(obj, newTab) {
        var $this = obj,
            link = $this.find('a:first'),
            href = link.attr('href'),
            target = link.attr('target');

        if (window.dataLayer) {
            dataLayer.push({'GTMclickableOpen': href});
        }

        if (target == '_blank' || newTab) {
            window.open(href);
        } else {
            window.location.href = href;
        }
    }

    function initScope($scope) {
        $scope.find('.isClickable').on('click', function (evt) {
            if (!$(evt.target).is('a')) {
                isClickable($(this));
            }
        });
    }

    return initScope;
}());


app.formbuilder = function () {
    var CustomInput = $('.formbuilder-form .checkbox, .formbuilder-form .radio');
    var CustomInputInline = $('.formbuilder-form .checkbox-inline, .formbuilder-form .radio-inline');

    if ($(CustomInput).length) {
        $(CustomInput).find('label').append('<span></span>');
    }
    if ($(CustomInputInline).length) {
        $(CustomInputInline).append('<span></span>');
    }

    var inputs = $('.formbuilder-form .form-control');
    inputs.each(function () {
        var $this = $(this),
            $errorBox = $this.closest('.form-group').find('.form-errors');
        $errorBox.insertBefore($this);
    });

    $('.formbuilder-form select').wrap('<div class="select"></div>');
};


app.showCountryMessage = function () {
    var session_data = sessionStorage.getItem('countryInfoModal');
    var session_data_usercountry = sessionStorage.getItem('user_location');

    if (!session_data) {
        var userLocation = JSON.parse(session_data_usercountry);
        var configCountry = _config.country;
        if (_config.country == 'vi') {
            configCountry = 'VN';
        }
        if (!userLocation) {
            app.checkCountry();
            setTimeout(function () {
                var session_data = sessionStorage.getItem('countryInfoModal');
                var session_data_usercountry = sessionStorage.getItem('user_location');

                if (!session_data) {
                    var userLocation = JSON.parse(session_data_usercountry);
                    var configCountry = _config.country;
                    if (_config.country == 'vi') {
                        configCountry = 'VN';
                    }

                    if (configCountry != userLocation.code) {
                        $('#countryInfoModal').modal('show');
                        sessionStorage.setItem('countryInfoModal', true);
                    }
                }
            }, 1000);
        } else {
            if (configCountry != userLocation.code) {
                $('#countryInfoModal').modal('show');
                sessionStorage.setItem('countryInfoModal', true);
            }

        }
    }


    $('#chooseCountry').on('click', function (evt) {
        $('#countryModal').modal('show');
    });

};


app.paldrive = function () {

    var assortment = $('#assortment').val();
    $('#assortment-search').attr('value', assortment);

    $('#assortment').on('change', function () {
        var assortment = $(this).val();
        if (assortment) {
            $('#assortment-search').attr('value', assortment);
        }
    });
};

app.paldriveVisitorLocationPageReload = function () {
    // force page-reload on location update
    $('body').on('visitorLocationUpdate', function (event) {
        history.go();
    });
};
app.modules.paldriveVisitorLocationOnPageLoad = function () {
    // must be module
    // trigger location-read on page-load
    var event = $.Event('visitorLocationRead');
    $('body').trigger(event);
};

app.modules.paldriveVisitorLocation = function ($scope) {

    // extracted from targeting.js
    // see http://clubmate.fi/setting-and-reading-cookies-with-javascript/
    var Cookie = {
        set: function (name, value, days) {
            var expires;
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }

            document.cookie = name + "=" + value + expires + "; path=/";
        },

        get: function (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }

            return null;
        }
    };

    var util = {
        featureDetect: (function () {
            // most tests come from to modernizr (MIT license)
            // https://github.com/Modernizr/Modernizr/tree/master/feature-detects
            var tests = {
                localStorage: function () {
                    var v = 'test';

                    try {
                        localStorage.setItem(v, v);
                        localStorage.removeItem(v);

                        return true;
                    } catch (e) {
                        return false;
                    }
                },

                sessionStorage: function () {
                    var v = 'test';

                    try {
                        sessionStorage.setItem(v, v);
                        sessionStorage.removeItem(v);

                        return true;
                    } catch (e) {
                        return false;
                    }
                },

                json: function () {
                    return 'JSON' in window && 'parse' in JSON && 'stringify' in JSON;
                },

                geolocation: function () {
                    return 'geolocation' in navigator;
                }
            };

            var results = {};

            return function (type) {
                if ('undefined' === typeof tests[type]) {
                    throw new Error('Test ' + type + ' is not defined');
                }

                if ('undefined' === typeof results[type]) {
                    results[type] = tests[type].call();
                }

                return results[type];
            };
        }()),
    };

    var visitorLocation = $scope.find('.js-visitor-location');
    visitorLocation.each(function () {

        var container = $(this);
        var trigger = container.find('a');

        function changeLocation() {
            _geolocation(false);
        }

        function _updateLocation(location) {
            // trigger custom event
            var event = $.Event('visitorLocationUpdate');
            event.location = location;
            $('body').trigger(event);
        }


        function _geolocation(skipUpdateFromStorage) {
            if (!util.featureDetect('geolocation') || !util.featureDetect('json') || !util.featureDetect('sessionStorage')) {
                return;
            }
            var cookieName = '_pc_tgl';

            var location;
            if (location = sessionStorage.getItem(cookieName)) {
                Cookie.set(cookieName, location);
                if (!skipUpdateFromStorage) {
                    _updateLocation(location);
                }
            } else {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var serialized = JSON.stringify({
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                        alt: position.coords.altitude
                    });

                    Cookie.set(cookieName, serialized);
                    sessionStorage.setItem(cookieName, serialized); // store to session storage for further usage
                    _updateLocation(location);
                }, function (error) {
                    console.error('[TARGETING] Failed to load geolocation', error);
                });
            }
        }


        trigger.on('click', function (e) {
            e.preventDefault();
            changeLocation();
        });

        $scope.on('visitorLocationRead', function (e) {
            e.stopPropagation();
            _geolocation(true);
        });
    });

};

app.showPaldriveProductOfferRequest = function () {
    $('#offerRequestModal').modal('show');
};

app.modules.paldriveTrackDownloads = function ($scope) {
    $scope.find('.js-track-download').on('click', function () {
        if (window.dataLayer) {


            var dlComponent = 'download button block';
            var dlElement = 'document';
            var dlElementName = '';
            var dlElementType = '';
            var dlContentName = '';
            var dlPosition = '';
            var dlElementId = '';

            if ($(this).attr('data-link')) {
                var href = $(this).attr('data-link');
            } else {
                var href = $(this).attr('href');
            }

            var result = href.indexOf("http");

            if (result == 0) {
                var finalClickUrl = href;
            } else {
                var finalClickUrl = encodeURI("https://" + window.location.host + href);
            }

            if ($(this).attr('data-component')) {
                dlComponent = $(this).attr('data-component');
            }

            if ($(this).attr('data-element')) {
                dlElement = $(this).attr('data-element');
            }

            if ($(this).attr('data-name')) {
                dlElementName = $(this).attr('data-name');
            }

            if ($(this).attr('data-id')) {
                dlElementId = $(this).attr('data-id');
            }

            if ($(this).attr('data-type')) {
                dlElementType = $(this).attr('data-type');
            }

            if ($(this).attr('data-content-name')) {
                dlContentName = $(this).attr('data-content-name');
            }

            if ($(this).attr('data-position')) {
                dlPosition = $(this).attr('data-position');
            }

            dataLayer.push({
                event: "fileDownload",
                component: dlComponent,
                element: dlElement,
                elementName: dlElementName,
                elementType: dlElementType,
                elementId: dlElementId,
                clickUrl: finalClickUrl,
                contentName: dlContentName,
                position: dlPosition
            });
        }
    });
};

app.showPaldriveProductOfferRequestSuccess = function () {
    $('#offerRequestModalSuccess').modal('show');
    var trackingTitle = $('#offerRequestModalSuccess').attr('data-tracking-title');

    if (window.dataLayer) {
        dataLayer.push({
            'event': 'contactFormSuccess',
            'contactForm': {
                'type': 'paldrive modal form',
                'display': 'modal',
                'title': trackingTitle,
                'department': 'sales',
                'purpose': 'seller contact request'
            }
        });
    }
};

app.anchorScrollOnLoad = function () {
    if (window.location.hash && window.location.hash.indexOf('msdynmkt') == -1) {
        var $target = $(window.location.hash);

        console.log('$target', $target)

        $('html, body').animate({
            scrollTop: $target.offset().top - 115
        }, 500);
    }
};

app.productGrid = function () {
    $.loadScript('/static/build/js/product-grid.min.js').done(function () {
        app.productGrid();
        app.modules.productGrid($('body'));
    });
};

app.modules.productGridSlider = function ($scope) {
    var $slider = $scope.find('.js-product-grid-slider');

    $.when(
        $.loadScript('/static/js/product-grid.js'),
        $.loadScript('/static/build/js/libs/nouislider.min.js')
    ).done(function () {
        $slider.each(function () {
            var $container = $(this);
            var slider = $container.find('.js-product-grid-slider__slider')[0];
            var $minInput = $container.find('.js-product-grid-slider__min');
            var $maxInput = $container.find('.js-product-grid-slider__max');
            var $minTextInput = $container.find('.js-product-grid-slider__min-text');
            var $maxTextInput = $container.find('.js-product-grid-slider__max-text');

            var min = 0;
            var max = 100;
            var step = 1;
            var inlineOptions = $container.data('options');
            if ($.isPlainObject(inlineOptions)) {
                if (inlineOptions.hasOwnProperty('min')) {
                    min = inlineOptions.min;
                }
                if (inlineOptions.hasOwnProperty('max')) {
                    max = inlineOptions.max;
                }
                if (inlineOptions.hasOwnProperty('step')) {
                    step = inlineOptions.step;
                }
            }

            noUiSlider.create(slider, {
                start: [
                    $minInput.val() || min,
                    $maxInput.val() || max
                ],
                connect: true,
                range: {
                    'min': min,
                    'max': max
                },
                step: step
            });

            /* product-grid.input-changed or changed to react to changes from the product grid */
            $minInput.on('product-grid.input-changed', function () {
                setMin(this.value !== '' ? this.value : min)
            });

            /* product-grid.input-changed or changed to react to changes from the product grid */
            $maxInput.on('product-grid.input-changed', function () {
                setMax(this.value !== '' ? this.value : max);
            });

            $minTextInput.on('change', function () {
                // todo parses localized number string to number
                var val = +$(this).val();

                setMin(val);
            });
            $maxTextInput.on('change', function () {
                // todo parses localized number string to number
                var val = +$(this).val();

                setMax(val);
            });

            slider.noUiSlider.on('update', function (values, handle) {
                var value = +values[handle];
                if (handle) {
                    setMaxText(value);
                } else {
                    setMinText(value);
                }
            });

            slider.noUiSlider.on('change', function (values, handle) {
                /* trigger change to notify the product-grid*/
                if (handle) {
                    setMax(values[handle]);
                    $maxInput.trigger('change');
                } else {
                    setMin(values[handle]);
                    $minInput.trigger('change');
                }
            });

            function setMin(value) {
                value = +value || min;

                $minInput.val(+value === min ? null : value);
                slider.noUiSlider.set([value, null]);
                setMinText(value);
            }

            function setMinText(value) {
                value = +value || min;
                var text = value.toLocaleString(_config.local);

                $minTextInput.val(text);
                $minInput.data('text', text);
            }

            function setMax(value) {
                value = +value || max;

                $maxInput.val(+value === max ? null : value);
                slider.noUiSlider.set([null, value]);
                setMaxText(value);
            }

            function setMaxText(value) {
                value = +value || max;
                var text = value.toLocaleString(_config.local);

                $maxTextInput.val(text);
                $maxInput.data('text', text);
            }
        })
    });
};

app.modules.productGridTypeahead = function ($scope) {

    var $taInputs = $scope.find('.js-product-grid-typeahead');
    /*
        if (!window.typeaheadData) {
            console.warn('No TypeaheadData is set. Typeahead not initialized.')
            return;
        }
    */
    $.loadScript('/static/build/js/libs/typeahead.bundle.min.js').done(function () {
        $taInputs.each(function () {
            var $this = $(this);

            var typeAheadOptionsArray = [{
                hint: true,
                highlight: true,
                minLength: 1
            }];

            var autoOpenUrl = false;
            var autoOpenUrlNewWindow = false;

            var remoteURL = $this.data('remote-url');
            var bloodhound = null;
            if ($.type(remoteURL) === 'string' && remoteURL.length > 0 && remoteURL !== '#') {



                autoOpenUrl = true;
                autoOpenUrlNewWindow = $this.data('select-target') === '_blank';
                bloodhound = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: remoteURL,
                        wildcard: 'TERM'
                    }
                });

                typeAheadOptionsArray = [{
                    hint: true,
                    highlight: true,
                    minLength: 2
                }];

                typeAheadOptionsArray.push({
                    limit: 6,
                    display: 'name',
                    source: bloodhound,
                    templates: {
                        suggestion: function (data) {
                            var regexp = new RegExp(data._query, 'gi');
                            if (data.name) {
                                var nameDisplay = data.name.replace(regexp, '<mark>$&</mark>');
                                var numberDisplay = '';
                                if (data.number) {
                                    numberDisplay = ' <small>(' + data.number + ')</small>';
                                }

                                return '<div class="tt-suggestion tt-selectable small">' + nameDisplay + numberDisplay + '</div>';
                            }
                        }
                    }
                });


            } else if (window.typeaheadData) {
                bloodhound = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.ngram('text'),
                    queryTokenizer: Bloodhound.tokenizers.nonword,
                    local: typeaheadData
                });

                typeAheadOptionsArray.push({
                    limit: 6,
                    display: 'text',
                    source: bloodhound,
                    templates: {
                        suggestion: function (data) {
                            var regexp = new RegExp(data._query, 'gi');
                            if (data.text) {
                                return '<div class="tt-suggestion tt-selectable small">' + data.text.replace(regexp, '<mark>$&</mark>') + '</div>';
                            }
                        }
                    }
                });

            }

            if (bloodhound !== null) {

                $this.typeahead.apply($this, typeAheadOptionsArray);


                $this.on('typeahead:select typeahead:autocompleted', function (typeaheadObj, data) {
                    // todo: use product-grid or just open href?
                    // when an entry is selected, the according url is used for the filter-form-result
                    if (data['url']) {
                        if (autoOpenUrl) {
                            if (autoOpenUrlNewWindow) {
                                window.open(data['url']);
                            } else {
                                window.location.href = data['url'];
                            }
                        } else {
                            history.pushState({'url': data.url}, "title", data.url.replace('ajaxreload=true', ''));
                        }
                    }

                });

            }

        });
    });

};

app.modules.scrollAnimation = function ($scope) {
    var $scrollAnimation = $scope.find('.js-scroll-animation');

    if ($scrollAnimation.length > 0) {
        $.loadScript('/static/build/js/libs/aos.js').done(function () {
            $scrollAnimation.each(function () {
                AOS.init({
                    once: true
                });

                $(window).on('load', function () {
                    AOS.refresh();
                });
            });
        });
    }
};

app.modules.expandable = function ($scope) {
    $scope.find('.js-expandable').each(function () {
        var $expandableElement = $(this);

        var $tabParent = $expandableElement.closest('.tab-pane');
        if ($tabParent && $tabParent.length && !$tabParent.hasClass('active')) {
            var id = $tabParent.attr('id');
            var $tabTrigger = $('[data-toggle="tab"][href="#' + id + '"], [data-toggle="tab"][data-target="#' + id + '"]');

            $tabTrigger.on('shown.bs.tab', function () {
                initCollapseElement($expandableElement)
            });

            return;
        }

        initCollapseElement($expandableElement);
    });

    function initCollapseElement($expandableElement) {
        var expandableContent = $expandableElement.find('.js-expandable__content-wrapper');
        var maxHeight = expandableContent.outerHeight() + 100;

        if (expandableContent[0].scrollHeight > maxHeight) {
            $expandableElement.removeClass('is-not-expandable');
            $expandableElement.addClass('is-expandable is-collapsed');

            $expandableElement.find('.js-expandable__more').on('click', function (evt) {
                evt.preventDefault();
                $expandableElement.removeClass('is-collapsed');
            }).on('click', function (evt) {
                evt.preventDefault();
            });
        } else if (expandableContent[0].scrollHeight != 0) { // if display none
            $expandableElement.addClass('is-not-expandable').removeClass('is-collapsed');
        }
    }
};

app.checkCountry = function () {

    if (window.sessionStorage) {
        var session_data_usercountry = sessionStorage.getItem('user_location');
        if (!session_data_usercountry) {
            $.ajax({
                method: "GET",
                cache: false,
                url: "/checkcountry?dc=" + Date.now()
            }).done(function (msg) {
                sessionStorage.setItem('user_location', JSON.stringify(msg));
                if (sendDataLayerDetectedCountry) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "detectedCountry",
                        detectedCountry: {
                            code: msg.code
                        }
                    });
                    sendDataLayerDetectedCountry = false;
                }
            });
        }
    }
};

var onEnterViewPort = (function () {
    var subscriptions = [];
    var impressionInterval;
    var defaultSettings = {
        offset: 0
    };

    function onEnterViewPort($newElements, callback, settings) {
        $newElements.each(function (index) {
            subscriptions.push({
                $element: $newElements.eq(index),
                callback: callback,
                settings: $.extend({}, defaultSettings, settings)
            });
        });

        if (!impressionInterval) {
            impressionInterval = setInterval(function () {
                subscriptions = subscriptions.filter(function (subscription) {
                    return isElementInDom(subscription.$element);
                });

                var inViewport = subscriptions.filter(function (subscription) {
                    return isElementInViewport(subscription.$element, subscription.settings.offset);
                });

                subscriptions = subscriptions.filter(function (subscription) {
                    return !isElementInViewport(subscription.$element, subscription.settings.offset);
                });

                inViewport.forEach(function (subscription) {
                    subscription.callback.call(subscription.$element, subscription.$element);
                });

                if (subscriptions.length === 0) {
                    clearInterval(impressionInterval);
                    impressionInterval = null;
                }
            }, 200);
        }
    }

    function isElementInViewport(el, offset) {
        offset = offset || 0;
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        if (!isElementVisible(el)) {
            return false;
        }

        return (
            rect.bottom + offset >= 0 &&
            rect.top - offset <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.left <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    }

    function isElementVisible(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return !(rect.top === 0 &&
            rect.bottom === 0 &&
            rect.height === 0 &&
            rect.width === 0
        );
    }

    function isElementInDom(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        return document.body.contains(el);
    }

    return onEnterViewPort;
}());


app.modules.lazyImg = function ($scope) {
    var settings = {
        offset: window.innerHeight / 2
    };

    // this uses a different approach (compared to the package) to get the picture-tag, because the picture tag of the
    // header image has a height of zero - so isElementVisible() of onEnterViewport is false
    onEnterViewPort($scope.find('.js-lazy-img'), function (img) {
        var $img = $(img);
        if ($img.closest('picture').length > 0) {
            $img = $(img).closest('picture');
        }

        if ($img.is('picture')) {
            $img.find('source, img').each(function () {
                $(this).attr('srcset', $(this).data('srcset'));
                $(this).attr('src', $(this).data('src'));
            });
        } else {
            $img.attr('srcset', $img.data('srcset'));
            $img.attr('src', $img.data('src'));
        }

        picturefill({
            reevaluate: true
        });
    }, settings);
};

app.modules.filterableContactPerson = function ($scope) {

    $scope.find('.js-contact-person-reset').on('click', function (evt) {
        console.log('click');
        evt.preventDefault();

        var selects = $scope.find('select');
        var resultContainer = $scope.find('.contacts-results');
        var regionContainer = $scope.find('.js-region-container');
        var url = _config.filterableContactPersonUrl;
        var resetCondition = _config.resetCondition;


        $.ajax({
            method: "POST",
            url: url,
            data: resetCondition
        }).done(function (msg) {
            resultContainer.html(msg);
            selects.val('');
            //regionContainer.attr('disabled', 'disabled');
            app.initModules(resultContainer);
        });

    });

    $scope.find('.js-choose-filter-country').on('change', function (evt) {
        var country = $(this).val();
        var preselectOptions = $scope.find('.js-preselect-container')[0].value;
        var preselectParam = '';
        if(preselectOptions) {
            preselectParam = '&preselect=' + preselectOptions;
        }
        var url = _config.filterableContactPersonCountryDataUrl + '?country=' + country + preselectParam;
        var regionContainer = $scope.find('.js-region-container');

        $.ajax({
            method: "GET",
            url: url
        }).done(function (msg) {
            regionContainer.html(msg.regionView);
            if(msg.hasRegions) {
                regionContainer.removeAttr('disabled');
            } else {
                if(!regionContainer.attr('disabled')) {
                    regionContainer.attr('disabled', '');
                }
            }
        });

    });

    $scope.find('.js-filterable-contact-person-form').on('submit', function (evt) {

        evt.preventDefault();
        var resultContainer = $scope.find('.contacts-results');
        var filterButton = $scope.find('.contact-person-filterbutton');
        var url = _config.filterableContactPersonUrl + '?' + $(this).serialize();

        filterButton.attr('disabled', 'disabled');

        $.ajax({
            method: "GET",
            url: url
        }).done(function (msg) {
            resultContainer.html(msg);
            filterButton.removeAttr('disabled');
            app.initModules(resultContainer);
        });
    });

};

app.modules.selectCattetCountry = function ($scope) {

    var locationInfo;
    if (_config.jobstart == true) {

        if (!_config.startpath) {
            var session_data_usercountry = sessionStorage.getItem('user_location');
            if (session_data_usercountry) {
                locationInfo = JSON.parse(session_data_usercountry);
                $("option[value='" + locationInfo.code + "']").attr('selected', 'selected');
                getCitylist(locationInfo.code, _config.place);
            }
        }

        var mrversion = 0;
        if (_config.marineversion) {
            mrversion = 1;
        }

        var detailLinkPattern = 'karrieredetail';
        if (_config.detailLinkPattern) {
            detailLinkPattern = _config.detailLinkPattern;
        }

        var lang = _config.lang;
        var updatedLang = lang.replace("-", "_");

        var ajaxLang = _config.ajaxLangForTranslations;

        if(updatedLang != ajaxLang) {
            updatedLang = ajaxLang;
        }

        // preselected load
        if (_config.startpath) {
            //var url = "/ajax-jobsearch?language=" + _config.lang + '&detailLinkPattern=' + detailLinkPattern + '&pathinfo=' + _config.pathinfo + '&marineversion=' + mrversion + '&' + _config.startpath + '&target=' + _config.target;
            var url = "/ajax-jobsearch?language=" + updatedLang + '&detailLinkPattern=' + detailLinkPattern + '&pathinfo=' + _config.pathinfo + '&marineversion=' + mrversion + '&' + _config.startpath + '&target=' + _config.target;
        }
        /*
        else if(locationInfo) {
            var url = "/ajax-jobsearch?language=" + _config.lang + '&detailLinkPattern=' + detailLinkPattern + '&pathinfo=' + _config.pathinfo + '&marineversion=' + mrversion + '&target=' + _config.target + '&country=' + locationInfo.code;
        }*/
        else {
            //var url = "/ajax-jobsearch?language=" + _config.lang + '&detailLinkPattern=' + detailLinkPattern + '&pathinfo=' + _config.pathinfo + '&marineversion=' + mrversion + '&target=' + _config.target;
            var url = "/ajax-jobsearch?language=" + updatedLang + '&detailLinkPattern=' + detailLinkPattern + '&pathinfo=' + _config.pathinfo + '&marineversion=' + mrversion + '&target=' + _config.target;
        }

        // initial load
        $.ajax({
            method: "GET",
            url: url
        }).done(function (msg) {
            $('.js-searchresult').html(msg);
            app.initModules($('.js-searchresult'));
        });

        _config.jobstart = false;
    }


    $('#country').on('change', function () {
        var country = $(this).val();
        if (country) {
            getCitylist(country, _config.place);
        }
    });


    function getCitylist(country, place) {
        var lang = _config.lang;
        var updatedLang = lang.replace("-", "_");

        var ajaxLang = _config.ajaxLangForTranslations;

        if(updatedLang != ajaxLang) {
            updatedLang = ajaxLang;
        }

        $.ajax({
            method: "GET",
            url: "/ajax-jobcity?language=" + updatedLang + "&country=" + country + '&place=' + place
        }).done(function (msg) {
            $('#place').html(msg);
        });
    }

    $('.js-ajax-job-search').on('click', function (evt) {

        evt.preventDefault();

        var pathinfo = _config.pathinfo;

        if (_config.pathinfoFormsubmit) {
            pathinfo = _config.pathinfoFormsubmit;
        }


        var formdata = $(this).parents('form').serialize();
        history.pushState({}, "", pathinfo + "?" + formdata + '&submit=1&page=1');

        var lang = _config.lang;
        var updatedLang = lang.replace("-", "_");

        var ajaxLang = _config.ajaxLangForTranslations;

        if(updatedLang != ajaxLang) {
            updatedLang = ajaxLang;
        }

        $.ajax({
            method: "GET",
            url: "/ajax-jobsearch?language=" + updatedLang + "&" + formdata
        }).done(function (msg) {
            $('.js-searchresult').html(msg);
            app.initModules($('.js-searchresult'));
        });

    });

    $scope.find('.js-isAjax').on('click', function (evt) {

        evt.preventDefault();

        var href = $(this).attr('href');

        var str = document.URL;
        var res = str.replace(/&page=[0-9]+/g, "&page=" + $(this).data('page'));
        history.pushState({}, "", res);

        $.ajax({
            method: "GET",
            url: href
        }).done(function (msg) {
            $('.js-searchresult').html(msg);
            app.initModules($('.js-searchresult'));
        });

    });

};


app.modules.videoJs = function ($scope) {
    app.modules.videoJs.id || (app.modules.videoJs.id = 1);
    $.getScript('/static/build/js/libs/video.js').done(function () {
        $scope.find('.js-video-js').each(function () {
            var id = $(this).prop('id');
            if (!id) {
                id = 'video-js-id-' + app.modules.videoJs.id++;
                $(this).prop('id', id);
            }
            videojs(id);
        });
    });
};

app.modules.iframeVideoPoster = function ($scope) {
    $scope.find('.js-iframe-video').on('click', function (evt) {
        evt.preventDefault();
        videoId = $(this).attr('data-video-id');
        videoType = $(this).attr('data-video-type');

        if (videoType == "youtube") {
            $(this).find('.js-iframe-video__img').replaceWith('<iframe class="embed-responsive-item js-iframe-video__frame" width="1140" height="641" src="https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1" allow="autoplay" frameborder="0" allowfullscreen></iframe>');
        } else {
            $(this).find('.js-iframe-video__img').replaceWith('<iframe class="embed-responsive-item js-iframe-video__frame" width="1140" height="641" src="https://player.vimeo.com/video/' + videoId + '?autoplay=1&amp;color=ffffff" allow="autoplay; fullscreen; picture-in-picture" frameborder="0" allowfullscreen></iframe>');
        }

        $(this).find('.js-iframe-video__play').remove();
    });
};

app.modules.scrollToTop = function ($scope) {
    $scope.find('.js-scroll-to-top').click(function () {
        $("html, body").animate({scrollTop: 0}, 500);
        return false;
    });
};

app.modules.hashAccordion = function ($scope) {
    $scope.find('.js-hash-accordion__collapse').click(function () {
        var href = $(this).attr('href');

        if ($(this).hasClass('collapsed')) {
            setTimeout(function () {
                history.replaceState(null, null, href);
            }, 100);
        } else {
            history.replaceState(null, null, '#empty');
        }
    });


    if (window.location.hash) {
        var $target = $(window.location.hash);
        var offset = 50;
        if (matchMedia('(min-width: 768px)').matches) {
            offset = 90;
        }
        $target.collapse('show');
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $target.offset().top - offset
            }, 500);
        }, 100);
    }
};

app.modules.svgAnimatedCircle = function ($scope) {

    var $animatedCircle = $scope.find('.js-animated-circle');

    $.loadScript('/static/js/libs/jquery.inview.js').done(function () {
        $animatedCircle.each(function () {
            var $this = $(this);

            $this.on('inview', function (event, isInView) {

                $(this).addClass('in-view');

                if (isInView) {
                    $(this).off('inview');
                }
            });
        });

    });

};


app.modules.languagedownload = function ($scope) {

    $scope.find('.downloadlanguage').on('change', function () {

        var selectedLanguage = $(this).val();

        var lang = _config.lang;
        var updatedLang = lang.replace("-", "_");

        var ajaxLang = _config.ajaxLangForTranslations;

        if(updatedLang != ajaxLang) {
            updatedLang = ajaxLang;
        }

        $.ajax({
            method: "GET",
            url: "/ajax-downloads?language=" + updatedLang + "&dllanguage=" + selectedLanguage + "&prodId=" + _config.productid
        }).done(function (msg) {
            $('.downloadrows').html(msg);
            app.initModules($('.downloadrows'));
        });

    });

};

app.modules.lightbox = function ($scope) {
    $.loadScript('/static/build/js/libs/lightgallery.min.js').done(function () {

        $.loadScript('/static/build/js/libs/lg-video.min.js');
        $.loadScript('/static/build/js/libs/froogaloop.js');
        $.loadScript('/static/build/js/libs/video.js');

        var lightboxGroups = $scope.find('.js-lightbox-group');

        lightboxGroups.each(function () {
            $(this).lightGallery({
                selector: '.js-lightbox-group__item',
                animateThumb: false,
                download: false,
                videojs: true,
                counter: false,
                prevHtml: "<span class='icon icon-arrow-left text-default'></span>",
                nextHtml: "<span class='icon icon-arrow-right text-default'></span>",
                youtubePlayerParams: {
                    rel: 0
                }
            });
        });

        //prevent isClickable
        $scope.find('.js-lightbox-group__item').on('click', function (evt) {
            evt.stopImmediatePropagation();
        });
    });
};

app.modules.adaptableSlider = function ($scope) {
    var $slider = $scope.find('.js-adaptable-slider');

    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var slickOptions = {
            slidesToShow: 4,
            rtl:isRtlPage,
            nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>',
            dots: true,
            customPaging: function (slider, i) {
                var count = i + 1;
                if (count < 10) {
                    count = '0' + count
                }
                return '<button class="slick-dots__btn" type="button" role="button"><span class=slick-dots__btn__text>' + count + '</span></button>';
            }
        };

        $slider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            if ($this.data('slides-to-show')) {
                options.slidesToShow = $this.data('slides-to-show');
            }

            $this.slick(options);

            var $tabPaneParent = $this.closest('.tab-pane');
            if ($tabPaneParent && $tabPaneParent.length) {
                /*refresh the slider when it was hidden in a tab*/
                var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
                $tabTrigger.one('shown.bs.tab', function () {
                    $this.slick('setPosition');
                });
            }

            var $collapseParent = $this.closest('.panel-collapse');
            if ($collapseParent && $collapseParent.length) {
                /*refresh the slider when it was hidden in a collapse*/
                var $collapseTrigger = $collapseParent.attr('id');
                $('#'+$collapseTrigger).one('shown.bs.collapse', function () {
                    $this.slick('setPosition');
                });
            }
        });
    });
};

app.modules.slider = function ($scope) {
    var $slider = $scope.find('.js-slider');

    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var slickOptions = {
            slidesToShow: 1,
            rtl:isRtlPage,
            nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>',
            dots: true,
            customPaging: function (slider, i) {
                var count = i + 1;
                if (count < 10) {
                    count = '0' + count
                }
                return '<button class="slick-dots__btn" type="button" role="button"><span class=slick-dots__btn__text>' + count + '</span></button>';
            },
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        adaptiveHeight: true
                    }
                }
            ]
        };

        $slider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            if ($this.data('slider-container')) {
                options.appendDots = $this.closest($this.data('slider-container'));
            }

            $this.slick(options);

            if ($this.data('slick-video')) {
                $this.find('video').get(0).play();
            }
        });

        $slider.find('.hero-video__item video').show();


    });
};

app.modules.challengeTeaserSlider = function ($scope) {
    var $slider = $scope.find('.js-challenge-teaser-slider');

    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var slickOptions = {
            slidesToShow: 1,
            rtl:isRtlPage,
            arrows: true,
            dots: false,
            nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>',
        };

        $slider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            $this.slick(options);
        });
    });
};

app.modules.newsTicker = function ($scope) {
    var $newsTicker = $scope.find('.js-news-ticker');

    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var slickOptions = {
            slidesToShow: 1,
            rtl:isRtlPage,
            arrows: true,
            dots: true,
            nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>',
        };

        $newsTicker.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            $this.slick(options);
        });
    });
};

app.modules.teaserSlider = function ($scope) {
    var $teaserSlider = $scope.find('.js-teaser-slider');

    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var slickOptions = {
            slidesToShow: 3,
            rtl:isRtlPage,
            slidesToScroll: 3,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            customPaging: function (slider, i) {
                var count = i + 1;
                if (count < 10) {
                    count = '0' + count;
                }
                return '<button class="slick-dots__btn" type="button" role="button"><span class=slick-dots__btn__text>' + count + '</span></button>';
            }
        };

        $teaserSlider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            if ($this.data('slider-container')) {
                options.appendDots = $this.closest($this.data('slider-container'));
            }

            $this.slick(options);
        });
    });
};

app.modules.teaserSliderXS = function ($scope) {
    if (matchMedia('(max-width: 767px)').matches) {
        var $teaserSlider = $scope.find('.js-teaser-slider-xs');

        $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
            var slickOptions = {
                slidesToShow: 1,
                rtl:isRtlPage,
                arrows: false,
                dots: true,
                customPaging: function (slider, i) {
                    var count = i + 1;
                    if (count < 10) {
                        count = '0' + count;
                    }
                    return '<button class="slick-dots__btn" type="button" role="button"><span class=slick-dots__btn__text>' + count + '</span></button>';
                }
            };

            $teaserSlider.each(function () {
                var $this = $(this),
                    options = $.extend({}, slickOptions);

                if ($this.data('slider-container')) {
                    options.appendDots = $this.closest($this.data('slider-container'));
                }

                $this.slick(options);
            });
        });
    }
};

app.modules.multipleSlider = function ($scope) {
    // get sliders on init to prevent multiple initialization of slick (because they are ajax-included and loadscript is async too)
    var $multipleSliders = $scope.find('.js-multiple-slider');


    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var defaultMainSlickOptions = {
            speed: 500,
            rtl:isRtlPage,
            nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>',
            dots: true,
            customPaging: function (slider, i) {
                var count = i + 1;
                if (count < 10) {
                    count = '0' + count;
                }
                return '<button class="slick-dots__btn slick-dots__btn--secondary" type="button" role="button"><span class=slick-dots__btn__text>' + count + '</span></button>';
            },
            fade: true,
            cssEase: 'linear'
        };
        var defaultImageSlickOptions = {
            speed: 500,
            rtl:isRtlPage,
            arrows: false,
            slidesToShow: 1,
            swipeToSlide: true,
            slidesToScroll: 1
        };

        $multipleSliders.each(function (index) {
            var $sliderWrapper = $(this);
            var $mainSlider = $sliderWrapper.find('.js-mulitple-slider__main');
            var $thumbSlider = $sliderWrapper.find('.js-multiple-slider__image');
            var $sliderNav = $sliderWrapper.find('.js-multiple-slider__nav');
            var mainSlickOptions = $.extend({}, defaultMainSlickOptions);

            var mainId = 'mulitple-slider-main-' + index;
            var thumbId = 'mulitple-slider-thumb-' + index;

            $mainSlider.attr('id', mainId);
            $thumbSlider.attr('id', thumbId);

            mainSlickOptions.asNavFor = '#' + thumbId;
            mainSlickOptions.appendDots = $sliderNav;
            mainSlickOptions.appendArrows = matchMedia('(max-width: 767px)').matches ? $thumbSlider : $sliderNav;

            $thumbSlider.slick($.extend({}, defaultImageSlickOptions, {
                asNavFor: '#' + mainId
            }));

            $mainSlider.slick(mainSlickOptions);

            $mainSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var slideElementPosition = currentSlide+1;
                var slideElementText = "slide toggle previous";
                var totalSlides = slick.slideCount;

                if(nextSlide+1 > slideElementPosition) {
                    slideElementText = "slide toggle next";
                }

                /*klick auf next bei letztem slide*/
                if((slideElementPosition == totalSlides) && (nextSlide == 0)) {
                    slideElementText = "slide toggle next";
                }

                /*klick auf prev bei erstem slide*/
                if((slideElementPosition == 1) && (nextSlide+1 == totalSlides)) {
                    slideElementText = "slide toggle previous";
                }

                if (window.dataLayer) {
                    dataLayer.push({
                        event: "sliderToggle",
                        component: "highlight slider",
                        element: slideElementText,
                        elementName: "",
                        elementType: "",
                        clickUrl: "",
                        contentName: "",
                        position: slideElementPosition
                    });
                }

            });
        });
    });
};

app.modules.imgGridSlider = function ($scope) {
    var slickOptions = {
        slidesToShow: matchMedia('(max-width: 767px)').matches ? 1 : 3,
        rtl:isRtlPage,
        swipeToSlide: true,
        speed: 200,
        infinite: false,
        variableWidth: matchMedia('(max-width: 767px)').matches ? false : true,
        nextArrow: '<button type="button" class="slick-next btn slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
        prevArrow: '<button type="button" class="slick-prev btn slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>'
    };

    var $sliders = $scope.find('.js-img-grid-slider');
    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        $sliders.each(function () {
            var $slider = $(this);

            var $tabPaneParent = $slider.closest('.tab-pane');

            if (!$tabPaneParent || !$tabPaneParent.length) {
                initSlider($slider);
            } else {
                /*refresh the slider when it was hidden in a tab*/
                var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
                $tabTrigger.one('shown.bs.tab', function () {
                    initSlider($slider);
                });
            }



            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var slideElementPosition = currentSlide+1;
                var slideElementText = "slide toggle previous";

                if(nextSlide+1 > slideElementPosition) {
                    slideElementText = "slide toggle next";
                }

                if (window.dataLayer) {
                    dataLayer.push({
                        event: "sliderToggle",
                        component: "media gallery slider",
                        element: slideElementText,
                        elementName: "",
                        elementType: "",
                        clickUrl: "",
                        contentName: "",
                        position: slideElementPosition
                    });
                }

            });
        });
    });

    function initSlider($slider) {
        $slider.children().each(function () {
            $(this).css('display', 'block');
            $(this).width($(this).width());
        });

        $slider.slick(slickOptions);
    }
};

app.modules.lightboxGallerySlider = function ($scope) {
    var slickOptions = {
        slidesToShow: matchMedia('(max-width: 767px)').matches ? 1 : 4,
        rtl:isRtlPage,
        swipeToSlide: true,
        speed: 200,
        infinite: false,
        nextArrow: '<button type="button" class="slick-next btn slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
        prevArrow: '<button type="button" class="slick-prev btn slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>'
    };

    var $sliders = $scope.find('.js-lightboxgallery-slider');
    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        $sliders.each(function () {
            var $slider = $(this);
            initSlider($slider);

            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var slideElementPosition = currentSlide+1;
                var slideElementText = "slide toggle previous";

                if(nextSlide+1 > slideElementPosition) {
                    slideElementText = "slide toggle next";
                }

                if (window.dataLayer) {
                    dataLayer.push({
                        event: "sliderToggle",
                        component: "lightbox gallery slider",
                        element: slideElementText,
                        elementName: "",
                        elementType: "",
                        clickUrl: "",
                        contentName: "",
                        position: slideElementPosition
                    });
                }

            });
        });
    });

    function initSlider($slider) {
        $slider.children().each(function () {
            $(this).css('display', 'block');
            $(this).width($(this).width());
        });

        $slider.slick(slickOptions);
    }
};

app.modules.mobileTeaserSlider = function ($scope) {
    if(matchMedia('(max-width: 767px)').matches) {
        var slickOptions = {
            slidesToShow: 1,
            rtl:isRtlPage,
            swipeToSlide: true,
            speed: 200,
            infinite: false,
            nextArrow: '<button type="button" class="slick-next btn slider__arrow" aria-label="Next"><span class="icon-btn__icon icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev btn slider__arrow" aria-label="Previous"><span class="icon-btn__icon icon icon-arrow-left"></span></button>'
        };

        var $sliders = $scope.find('.js-mobile-teaser-slider');
        $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
            $sliders.each(function () {
                var $slider = $(this);
                initSlider($slider);

                $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    var slideElementPosition = currentSlide+1;
                    var slideElementText = "slide toggle previous";

                    if(nextSlide+1 > slideElementPosition) {
                        slideElementText = "slide toggle next";
                    }

                    if (window.dataLayer) {
                        dataLayer.push({
                            event: "sliderToggle",
                            component: "mobile teaser slider",
                            element: slideElementText,
                            elementName: "",
                            elementType: "",
                            clickUrl: "",
                            contentName: "",
                            position: slideElementPosition
                        });
                    }

                });
            });
        });

        function initSlider($slider) {
            $slider.children().each(function () {
                $(this).css('display', 'block');
                $(this).width($(this).width());
            });

            $slider.slick(slickOptions);
        }
    }
};

app.modules.sliderWithThumbs = function ($scope) {
    $.loadScript('/static/build/js/libs/slick.min.js').done(function () {
        var defaultMainSlickOptions = {
            speed: 300,
            rtl:isRtlPage,
            arrows: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: true,
                        rtl:isRtlPage,
                        nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
                        prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>'
                    }
                }
            ]
        };
        var defaultThumbSlickOptions = {
            speed: 200,
            rtl:isRtlPage,
            slides: 3,
            nextArrow: '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left"></span></button>',
            slidesToShow: 3,
            swipeToSlide: true,
            slidesToScroll: 3,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: "0"
        };

        $scope.find('.js-slider-with-thumbs').each(function () {
            var mainSlickOptions = $.extend({}, defaultMainSlickOptions);
            var $mainSlider = $(this).find('.js-slider-with-thumbs__main');

            if (!matchMedia('(max-width: 767px)').matches) {
                var $thumbSlider = $(this).find('.js-slider-with-thumbs__thumbs');

                app.modules.sliderWithThumbs.elementId++;
                var mainId = 'slider-with-thumbs-main-' + app.modules.sliderWithThumbs.elementId;
                var thumbId = 'slider-with-thumbs-thumb-' + app.modules.sliderWithThumbs.elementId;

                $mainSlider.attr('id', mainId);
                $thumbSlider.attr('id', thumbId);

                mainSlickOptions.asNavFor = '#' + thumbId;

                $thumbSlider.slick($.extend({}, defaultThumbSlickOptions, {
                    asNavFor: '#' + mainId
                }));
            }

            $mainSlider.slick(mainSlickOptions);

            var $tabPaneParent = $mainSlider.closest('.tab-pane');
            if ($tabPaneParent && $tabPaneParent.length) {
                /*refresh the slider when it was hidden in a tab*/
                var $tabTrigger = $('[href="#' + $tabPaneParent.attr('id') + '"],[data-toggle=tab][data-target="#' + $tabPaneParent.attr('id') + '"]');
                $tabTrigger.one('shown.bs.tab', function () {
                    $mainSlider.slick('setPosition');
                    $thumbSlider.slick('setPosition');
                });
            }
        });
    });
};
app.modules.sliderWithThumbs.elementId = 0;

app.modules.tooltip = function ($scope) {
    $scope.find('.js-tooltip').tooltip();
};

app.modules.iReportOverlay = function ($scope) {
    var container = $scope.find('.js-ireport');
    var overlay = $scope.find('.js-ireport-overlay');

    if (_config.ireportmofification) {
        var mofification = _config.ireportmofification;
    } else {
        var mofification = '';
    }

    var myItem = 'ireport' + mofification;

    if (!localStorage.getItem(myItem)) {
        setTimeout(function () {
            container.removeClass('hidden');
            overlay.removeClass('hidden');
        }, 100);
    }

    $('body').on('click', '.js-ireport-close', function (e) {
        container.remove();
        overlay.remove();
        localStorage.setItem(myItem, 'closed');
    });
};

app.modules.scrollTo = (function () {
    function scrollTo($target, callback) {
        if (!$target || !$target.length) {
            console.warn("Can't scroll to '" + target + "'. Target element not found");
            return;
        }

        if (app.affixNavBar) {
            app.affixNavBar.disable();
        }

        var duration = Math.abs($target.offset().top - window.scrollY) / 8 + 100;

        $('html, body').stop().animate({
                scrollTop: $target.offset().top - 30
            },
            duration,
            'swing', function () {
                if (app.affixNavBar) {
                    app.affixNavBar.enable();
                }

                if (callback) {
                    callback();
                }
            }
        );
    }

    function focus($target) {
        if (typeof $target.attr('tabindex') == 'undefined') {
            $target.addClass('hide-focus');
            $target.attr('tabindex', '-1');
        }
        $target.focus();
    }

    return function ($scope) {
        $scope.find('.js-scroll-to').on('click', function (evt) {
            evt.preventDefault();
            var targetSelector = $(this).data('scroll-target') || $(this).attr('href');
            var $target = $(targetSelector);

            switch ($(this).data('toggle')) {
                case 'tab':
                    if ($target.hasClass('in')) {
                        scrollTo($target, function () {
                            focus($target);
                        });
                        evt.stopImmediatePropagation();
                        return;
                    }

                    /*scroll to parent because we can't know where the actual child is*/
                    scrollTo($target.parent(), function () {
                        focus($target);
                    });

                    /*update bootstrap nav classes because bootstrap doesn't handle them*/
                    var navTabTrigger = $('.nav [data-toggle="tab"]').filter('[href="' + targetSelector + '"], [data-target="' + targetSelector + '"]');
                    navTabTrigger.each(function () {
                        var $navItems = $(this).closest('.nav').find('li');

                        $navItems.removeClass('active')
                            .find('a').attr('aria-expanded', 'false');

                        $(this).attr('aria-expanded', 'true')
                            .parent().addClass('active');

                    });
                    break;

                case 'collapse':
                    if ($target.hasClass('in')) {
                        scrollTo($target, function () {
                            focus($target);
                        });
                        evt.stopImmediatePropagation();
                        return;
                    }

                    /*scroll to parent because we can't know where the actual child is*/
                    scrollTo($target.parent(), function () {
                        focus($target);
                    });

                    break;

                default:
                    scrollTo($target, function () {
                        focus($target);
                    });
            }
        });
    };
}());

app.modules.datepicker = (function () {
    function init($scope) {
        var datePicker = $scope.find('.js-datepicker');
        var datepickerMinDate = false;
        var datepickerMaxDate = false;


        if (datePicker.attr('data-datepicker-min-date')) {
            datepickerMinDate = datePicker.attr('data-datepicker-min-date');
        }

        if (datePicker.attr('data-datepicker-max-date')) {
            datepickerMaxDate = datePicker.attr('data-datepicker-max-date');
        }

        var defaultOptions = {
            minDate: datepickerMinDate ? new Date(datepickerMinDate) : 0,
            maxDate: datepickerMaxDate ? new Date(datepickerMaxDate) : null,
            nextText: '</span><span class="icon icon-arrow-right"></span>',
            prevText: '</span><span class="icon icon-arrow-right"></span>'
        };

        function addKeyboardSupport($datepicker) {
            function triggerSelect() {
                $('.ui-datepicker-current-day').click();
            }

            $datepicker.on('keydown', function (evt) {
                var newDate = $datepicker.datepicker('getDate');
                if (newDate == null) {
                    $datepicker.datepicker('setDate', new Date());
                    newDate = $datepicker.datepicker('getDate');
                }

                switch (evt.keyCode) {
                    case 37: /*left*/
                        newDate.setDate(newDate.getDate() - 1);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 38: /*up*/
                        newDate.setDate(newDate.getDate() - 7);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 39: /*right*/
                        newDate.setDate(newDate.getDate() + 1);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 40: /*down*/
                        newDate.setDate(newDate.getDate() + 7);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 33: /*page up*/
                        newDate.setDate(newDate.getDate() - 30);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 34: /*page down*/
                        newDate.setDate(newDate.getDate() + 30);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 13: /*enter*/
                        // selectedDate = newDate;
                        // triggerSelect();
                        $datepicker.datepicker('hide');
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                }

                if (newDate.getTime() != $datepicker.datepicker('getDate').getTime()) {
                    $datepicker.datepicker('setDate', newDate);
                }
            });
        }

        datePicker.closest('.form-group').addClass('has-calendar-icon');

        datePicker.datepicker(defaultOptions);


        if (datePicker.attr('data-datepicker-min-date') && datePicker.attr('data-datepicker-max-date')) {
            var timeZoneMinDate = defaultOptions.minDate.setMinutes(defaultOptions.minDate.getMinutes() + defaultOptions.minDate.getTimezoneOffset());
            var timeZoneMaxDate = defaultOptions.maxDate.setMinutes(defaultOptions.maxDate.getMinutes() + defaultOptions.maxDate.getTimezoneOffset());

            defaultOptions.minDate = new Date(timeZoneMinDate);
            defaultOptions.maxDate = new Date(timeZoneMaxDate);
        }

    }


    return function ($scope) {
        if (!_cfg.language) {
            console.warn('_config.lang is not set');
        }

        if (_cfg.language !== "en") {
            $.loadScript('/static/js/libs/i18n/jquery-ui-datepicker/datepicker-' + _cfg.language + '.js').done(function () {
                init($scope);
            }).fail(function () {
                init($scope);
            });
        } else {
            init($scope);
        }
    }

}());

app.modules.fender = function ($scope) {
    var $calculator = $scope.find('.js-fender-calculator'),
        resultBox = $calculator.find('.js-fender-calculator__result');

    //partial function from fender.js
    function initCalculateFender() {
        //tonnage inputs
        var tonn = $calculator.find('.js-fender-calculator__tonnage').val(),
            tonnB = $calculator.find('.js-fender-calculator__tonnage-b').val();

        //operation radios
        var dock = document.getElementById('dock1').checked,
            dock2 = document.getElementById('dock2').checked;

        //typ checkbox
        var objTypen = document.getElementById('type1');
        var typen = objTypen.checked;

        tonn = tonn * 1;
        tonnB = tonnB * 1;

        if (tonn == 0 || !tonn) {
            if (dock2) {
                alert('Please enter a value for "Tonnage" for both Ship A and Ship B');
            } else
                alert('Please enter a value for "Tonnage"');
        } else if (dock2 && (tonnB == 0 || !tonnB))
            alert('Please enter a value for "Tonnage" for both Ship A and Ship B');
        else if (!dock && !dock2)
            alert('Please select either "For Dock" or "For Ship-to-ship');
        else
            calculateFender(dock, tonn, tonnB, typen);
    }

    //partial function from fender.js
    function calculateFender(dock, tonn, tonnB, typen) {
        var size = String();
        var ant = String();
        var value;

        if (dock)
            value = tonn;
        else
            value = ((2 * tonn * tonnB) / (tonn + tonnB));

        if (value) {
            if (typen) {
                if (dock) {
                    switch (true) {
                        case (value <= 5):
                            size = '0.5 x 1.0';
                            ant = '3 or more';
                            break;
                        case (value > 5 && value <= 10):
                            size = '0.8 x 1.5';
                            ant = '3 or more';
                            break;
                        case (value > 10 && value <= 300):
                            size = '1.0 x 1.5';
                            ant = '3 or more';
                            break;
                        case (value > 300 && value <= 500):
                            size = '1.0 x 2.0';
                            ant = '3 or more';
                            break;
                        case (value > 500 && value <= 700):
                            size = '1.0 x 2.0';
                            ant = '3 or more';
                            break;
                        case (value > 700 && value <= 1000):
                            size = '1.0 x 2.0';
                            ant = '3 or more';
                            break;
                        case (value > 1000 && value <= 2000):
                            size = '1.5 x 2.5';
                            ant = '3 or more';
                            break;
                        case (value > 2000 && value <= 3000):
                            size = '1.5 x 2.5';
                            ant = '3 or more';
                            break;
                        case (value > 3000 && value <= 5000):
                            size = '1.5 x 3.0';
                            ant = '3 or more';
                            break;
                        case (value > 5000 && value <= 6000):
                            size = '2.0 x 3.0';
                            ant = '3 or more';
                            break;
                        case (value > 6000 && value <= 7000):
                            size = '2.0 x 3.0';
                            ant = '3 or more';
                            break;
                        case (value > 7000 && value <= 12000):
                            size = '2.0 x 3.5';
                            ant = '3 or more';
                            break;
                        case (value > 12000 && value <= 15000):
                            size = '2.5 x 4.0';
                            ant = '3 or more';
                            break;
                        case (value > 15000 && value <= 25000):
                            size = '2.5 x 5.5';
                            ant = '3 or more';
                            break;
                        case (value > 25000 && value <= 35000):
                            size = '2.5 x 5.5';
                            ant = '4 or more';
                            break;
                        case (value > 35000 && value <= 60000):
                            size = '3.3 x 4.5';
                            ant = '4 or more';
                            break;
                        case (value > 60000 && value <= 130000):
                            size = '3.3 x 6.5';
                            ant = '4 or more';
                            break;
                        case (value > 130000 && value <= 200000):
                            size = '3.3 x 6.5';
                            ant = '5 or more';
                            break;
                        default:
                            size = '4.5 x 9.0';
                            ant = '5 or more';
                            break;
                    }
                } else {
                    switch (true) {
                        case (value <= 5):
                            size = '0.5 x 1.0';
                            ant = '3 or more';
                            break;
                        case (value > 5 && value <= 10):
                            size = '0.8 x 1.5';
                            ant = '3 or more';
                            break;
                        case (value > 10 && value <= 300):
                            size = '1.0 x 1.5';
                            ant = '3 or more';
                            break;
                        case (value > 300 && value <= 500):
                            size = '1.0 x 2.0';
                            ant = '3 or more';
                            break;
                        case (value > 500 && value <= 700):
                            size = '1.2 x 2.0';
                            ant = '3 or more';
                            break;
                        case (value > 700 && value <= 1000):
                            size = '1.2 x 2.0';
                            ant = '3 or more';
                            break;
                        case (value > 1000 && value <= 2000):
                            size = '1.5 x 2.5';
                            ant = '3 or more';
                            break;
                        case (value > 2000 && value <= 3000):
                            size = '1.5 x 3.0';
                            ant = '3 or more';
                            break;
                        case (value > 3000 && value <= 5000):
                            size = '2.0 x 3.0';
                            ant = '3 or more';
                            break;
                        case (value > 5000 && value <= 6000):
                            size = '2.0 x 3.5';
                            ant = '3 or more';
                            break;
                        case (value > 6000 && value <= 7000):
                            size = '2.0 x 3.5';
                            ant = '3 or more';
                            break;
                        case (value > 7000 && value <= 12000):
                            size = '2.5 x 4.0';
                            ant = '3 or more';
                            break;
                        case (value > 12000 && value <= 25000):
                            size = '2.5 x 5.5';
                            ant = '3 or more';
                            break;
                        case (value > 25000 && value <= 35000):
                            size = '3.0 x 5.0';
                            ant = '4 or more';
                            break;
                        case (value > 35000 && value <= 130000):
                            size = '3.3 x 6.5';
                            ant = '4 or more';
                            break;
                        case (value > 130000 && value <= 200000):
                            size = '3.3 x 6.3';
                            ant = '5 or more';
                            break;
                        default:
                            size = '4.5 x 9.0';
                            ant = '5 or more';
                            break;
                    }
                }
            } else {
                switch (true) {
                    case (value <= 1000):
                        size = '1.0 x 2.0';
                        ant = '3 or more';
                        break;
                    case (value > 1000 && value <= 3000):
                        size = '1.5 x 3.0';
                        ant = '3 or more';
                        break;
                    case (value > 3000 && value <= 5000):
                        size = '2.0 x 3.5';
                        ant = '3 or more';
                        break;
                    case (value > 5000 && value <= 8000):
                        size = '2.0 x 3.5';
                        ant = '3 or more';
                        break;
                    case (value > 8000 && value <= 20000):
                        size = '3.3 x 4.5';
                        ant = '3 or more';
                        break;
                    case (value > 20000 && value <= 40000):
                        size = '3.3 x 4.5';
                        ant = '4 or more';
                        break;
                    case (value > 40000):
                        size = '3.3 x 4.5';
                        ant = '4 or more';
                        break;
                }
            }
        }

        displayResult(size, ant);
    }

    function displayResult(size, ant) {
        resultBox.removeClass('hidden');
        resultBox.find('.js-fender-calculator__result__size').text(size);
        resultBox.find('.js-fender-calculator__result__quantity').text(ant);
    }

    $scope.find('.js-fender-calculator__submit').on('click', function (evt) {
        evt.preventDefault();
        initCalculateFender();
    });

    $scope.find('.js-fender-calculator form').on('submit', function (evt) {
        evt.preventDefault();
        initCalculateFender();
    });

    $scope.find('.js-fender-calculator__reset').on('click', function (evt) {
        evt.preventDefault();

        $(this).closest('form')[0].reset();
        resultBox.addClass('hidden');
    });

    $scope.find('.js-fender-calculator input[type=radio]').on('change', function () {

        $('.js-fender-calculator input[type=radio]').each(function () {
            var $dependFields = $($(this).data('depend-fields'));

            if ($(this).data('depend-fields') && $(this).is(':checked')) {
                $dependFields.attr('hidden', false);
            } else if ($(this).data('depend-fields')) {
                $dependFields.attr('hidden', true);
                $dependFields.find('input').val('');
            }
        });
    });
};

function isFocusable($el) {
    var tabIndex = +$el.attr("tabindex");
    tabIndex = isNaN(tabIndex) ? -1 : tabIndex;
    return $el.is(":input, a[href], area[href], iframe") || tabIndex > -1;
}

/*app.toc*/
(function () {
    var id = 0;

    function addTocEntry(text, anchorId) {
        $tocList.append('<li><a class="sr-only sr-only-focusable" href="#' + anchorId + '">' + text + '</a></li>');
    }

    var $tocList;
    app.toc = function () {
        $tocList = $('.js-toc__list');
        if (!$tocList || !$tocList.length) {
            console.warn('can\'t render Table of content. No js-toc__list found');
        }

        $tocList.on('click', 'a', function () {
            var $target = $($(this).attr('href'));

            if (!$target || !$target.length) {
                console.warn('Could not jump to "', $(this).attr('href'), '". Element was not found');
                return;
            }

            var $tabPaneParent = $target.closest('.tab-pane:not(.active)');
            if ($tabPaneParent && $tabPaneParent.length) {
                var targetSelector = '#' + $tabPaneParent.attr('id');
                var $trigger = $('[data-toggle="tab"]').filter('[data-target="' + targetSelector + '"],[href="' + targetSelector + '"]');
                $trigger.tab('show');
                window.scrollTo(window.scrollX, $tabPaneParent.parent().offset().top);
            }

            var $collapseParent = $target.closest('.collapse:not(.in)');
            if ($collapseParent && $collapseParent.length) {
                $collapseParent.collapse('show');
                window.scrollTo(window.scrollX, $collapseParent.parent().offset().top);
            }
        });
    };

    app.modules.toc = function ($scope) {
        $scope.find('.js-toc__title').each(function () {
            var $title = $(this);
            var anchorId = 'toc-entry-target-' + id;
            $title.attr('id', 'toc-entry-target-' + id);
            if (!isFocusable($title)) {
                $title.attr('tabindex', '-1');
            }
            id++;
            addTocEntry($title.text(), anchorId);
        });
    };
}());

/*app.affixNavBar*/
if (!matchMedia('(max-width: 991px)').matches) {
    (function () {
        // Hide Header on on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 1;
        var navbarHeight;
        var defaultTopPosition;
        var $navbar;
        var $navbarContainer;
        var isTransitioning = false;
        var isFixed = false;
        var isDisabled = false;

        function scrollHandler() {
            var scrollTopPosition = $(this).scrollTop();
            if (Math.abs(lastScrollTop - scrollTopPosition) <= delta)
                return;

            if (isDisabled) {
                lastScrollTop = scrollTopPosition;
                return;
            }

            var navbarOffset = $navbar.offset().top;

            if (scrollTopPosition <= defaultTopPosition) {
                $navbar.removeClass('is-affix').css('top', 0).removeClass('is-transitioning');
                isFixed = false;
                isTransitioning = true;
                return;
            }

            if (lastScrollTop > scrollTopPosition) {
                /*scroll up*/
                if ($navbar.hasClass('js-affix--not-scrolling-up')) {
                    return;
                }
                if (!isFixed) {
                    if (isTransitioning) {
                        if (navbarOffset >= scrollTopPosition) {
                            /*end of transtion*/
                            isTransitioning = false;
                            isFixed = true;
                            $navbar.css('top', 0);
                            $navbar.addClass('is-affix');
                            $navbar.removeClass('is-transitioning');
                        }
                    } else {
                        $navbar.addClass('is-transitioning').css({
                            top: scrollTopPosition - navbarHeight
                        });
                        isTransitioning = true;
                    }
                }
            } else if (lastScrollTop < scrollTopPosition) {
                /*scroll down*/

                if (isFixed) {
                    $navbar.removeClass('is-affix');

                    $navbar.css({
                        top: lastScrollTop
                    }).addClass('is-transitioning');

                    isTransitioning = true;
                    isFixed = false;
                }

                if (isTransitioning) {
                    if (navbarOffset + navbarHeight <= scrollTopPosition) {
                        isTransitioning = false;
                    }
                }
            }

            lastScrollTop = scrollTopPosition;
        }

        app.affixNavBar = function () {
            $navbar = $('.js-affix-nav-bar');
            $navbarContainer = $('.js-affix-nav-bar-container');
            defaultTopPosition = $navbarContainer.offset().top;

            $(window).one('scroll', function () {
                navbarHeight = $navbar[0].getBoundingClientRect().height;
                /*get exact height (jquery returns rounded value)*/
                $navbarContainer.height(navbarHeight);
            });

            $(window).scroll(function (event) {
                didScroll = true;
            });

            requestAnimationFrame(function animationFrameHandler() {
                if (didScroll) {
                    scrollHandler();
                    didScroll = false;
                }
                requestAnimationFrame(animationFrameHandler);
            });
        };

        app.affixNavBar.disable = function (disableAtAffixState) {
            if (disableAtAffixState) {
                $navbar.addClass('is-affix').css('top', 0).removeClass('is-transitioning');
                isFixed = true;
                isTransitioning = false;
            } else {
                $navbar.removeClass('is-affix').css('top', 0).removeClass('is-transitioning');
                isFixed = false;
                isTransitioning = false;
            }

            isDisabled = true;
        };

        app.affixNavBar.enable = function () {
            isDisabled = false;
        };

        app.affixNavBar.getAffixNavBarHeight = function () {
            return $('.js-affix-nav-bar').height() || 0;
        };

        app.affixNavBar.isInDefaultState = function () {
            return !$navbar.hasClass('is-transitioning') && !$navbar.hasClass('is-affix');
        };


    }());
}

app.affixFooter = function () {
    var $footer,
        $footerContainer,
        defaultPosition;

    if (matchMedia('(min-width: 768px)').matches) {
        function scrollHandler() {
            if ($footer.offset().top >= defaultPosition) {
                $footerContainer.removeClass('is-fixed').addClass('is-bottom');
            }

            if ($(window).scrollTop() + window.innerHeight - $('.js-affix-footer-btn').outerHeight() <= $('.js-affix-footer-btn').offset().top) {
                $footerContainer.removeClass('is-bottom');
                $(window).off('scroll', scrollHandler);
            }
        }
    }


    $footer = $('.js-affix-footer');
    $footerContainer = $('.js-affix-footer-container');


    $('.js-affix-footer-btn').on('click', function (evt) {
        evt.preventDefault();

        if ($(this).closest('.affix-footer__buttons').hasClass('affix-bottom') && matchMedia('(min-width: 768px)').matches) {
            return false;
        }

        if (matchMedia('(min-width: 768px)').matches) {
            var footerHeight = $footer[0].getBoundingClientRect().height;
            /*get exact height (jquery returns rounded value)*/
            $footerContainer.height(footerHeight);

            defaultPosition = $footerContainer.offset().top;

            $(window).on('scroll', scrollHandler);
        }

        if (!$footerContainer.hasClass('is-fixed')) {
            $footerContainer.addClass('is-fixed');
        } else {
            $footerContainer.removeClass('is-fixed');
            if (matchMedia('(min-width: 768px)').matches) {
                $(window).off('scroll', scrollHandler);
            }
        }
    });
};

app.scrollTopButton = function () {

    $(window).bind('load', function () {
        // use on load so the height will be determined correctly
        $('.affix-footer__buttons').affix({
            offset: {
                top: 800,
                bottom: function () {
                    if (matchMedia('(min-width: 768px)').matches) {
                        return (this.bottom = $('.main-footer').outerHeight(true));
                    } else {
                        return 0;
                    }
                }
            }
        });
    });
};

app.modules.actionChanger = function ($scope) {
    $scope.find('.js-action-changer').on('submit', function () {
        var newAction = $(this).data('action');

        if (newAction) {
            $(this).attr('action', newAction);
        } else {
            $(this).attr('action', '');
        }
    });
};

app.modules.stickyCta = function ($scope) {
    var stickyCta = $scope.find('.js-sticky-cta');
    var stickyCtaImg = $scope.find('.js-sticky-cta__img');
    var stickyCtaCta = $scope.find('.js-sticky-cta__cta');

    if (stickyCta.length && matchMedia('(min-width: 768px)').matches) {
        $(window).scroll(function () {
            var stickyCtaImgHeight = stickyCtaImg.outerHeight();
            var stickyCtaCtaHeight = stickyCtaCta.outerHeight();
            var scroll = $(window).scrollTop();

            if (scroll > stickyCtaImgHeight-stickyCtaCtaHeight) {
                stickyCtaCta.addClass('is-sticky');
            } else {
                stickyCtaCta.removeClass('is-sticky');
            }
        });
    }
};

app.modules.affix = function ($scope) {

    var isRunning = false;
    var elements = [];


    var $newElements = $scope.find('.js-affix');

    if (!$newElements.length) {
        return;
    }

    elements = elements.concat($newElements.toArray().map(function (element) {
        var $element = $(element);
        var $placeholder = $element.closest('.js-affix__placeholder');
        var $container = $element.closest('.js-affix__container');

        $element.css('transform', 'translateZ(0)');

        if (!$container || !$container.length) {
            console.warn('Could not find parent ".js-affix__container" for element ', element);
            return null;
        }

        if (!$placeholder || !$placeholder.length) {
            console.warn('Could not find parent ".js-affix__placeholder" for element ', element);
            return null;
        }

        if ($placeholder && $placeholder.length) {
            $placeholder.css('min-height', element.getBoundingClientRect().height);
        }

        return {
            element: element,
            placeholder: $placeholder[0],
            container: $container[0],
            isAffix: false,
            offset: +$element.data('affix-offset') || 0
        }
    }).filter(function (x) {
        return !!x
    }));


    if (!isRunning) {
        isRunning = true;
        requestAnimationFrame(interval);
    }


    var lastScrollPosition = 0;

    function interval() {
        if (lastScrollPosition === window.scrollY) {
            requestAnimationFrame(interval);
            return;
        }

        lastScrollPosition = window.scrollY;

        elements.forEach(function (obj) {
            var elementRect = obj.placeholder.getBoundingClientRect();
            var containerRect = obj.container.getBoundingClientRect();

            if (obj.isAffix) {
                if (isContainerBottomReached(containerRect, elementRect, obj.offset)) {
                    $(obj.element).removeClass('is-affix').css({
                        position: 'relative',
                        top: containerRect.height - (elementRect.top - containerRect.top) - elementRect.height,
                        left: '',
                    });

                    obj.isAffix = false;
                }
                if (!isAffixTopReached(elementRect, obj.offset)) {
                    $(obj.element).removeClass('is-affix').css({
                        position: '',
                        top: '',
                        left: '',
                        width: '',
                    });

                    obj.isAffix = false;
                }
            } else {
                if (isAffixTopReached(elementRect, obj.offset) && !isContainerBottomReached(containerRect, elementRect, obj.offset)) {
                    $(obj.element).addClass('is-affix').css({
                        position: 'fixed',
                        top: obj.offset,
                        left: elementRect.left,
                        width: elementRect.width,
                    });

                    obj.isAffix = true;
                }
            }
        });

        requestAnimationFrame(interval);
    }


    function isContainerBottomReached(containerRect, elementRect, offset) {
        return containerRect.top + containerRect.height - offset - elementRect.height <= 0;
    }

    function isAffixTopReached(elementRect, offset) {
        return elementRect.top - offset <= 0
    }


};

app.modules.parsley = function ($scope) {

    var $forms = $scope.find('.js-parsley');

    app.loadParsley().done(function () {

        var options = $.extend({}, app.modules.parsley.options);

        if ($forms.hasClass('formbuilder-form')) {
            options.excluded = "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]";
        }

        $forms.parsley(options);

        $forms.each(function () {
            var $form = $(this);
            $form.find('input[type=file]').on('change', function () {
                const fileSize = this.files[0].size / 1024 / 1024; // in MiB
                var $errorContainer = $(this).closest('.form-group').find('.form-errors');
                var $button = $(this).closest('form').find('button[type=submit]');

                if (fileSize > 20) {
                    $(this).val('');
                    $errorContainer.addClass('has-error parsley-errors-list');
                    $errorContainer.append('<div class="text-left js-fileinput-error">'+ _config.translateFileSizeError +'</div>');
                    $button.prop('disabled', true);
                } else {
                    $errorContainer.removeClass('has-error parsley-errors-list');
                    $errorContainer.find('.js-fileinput-error').remove();
                    $button.prop('disabled', false);
                }
            });

            $form.parsley().on('field:error', function () {
                var parsleyId = this.__id__;
                var fieldClass = this.__class__;

                if (fieldClass == 'ParsleyFieldMultiple') {
                    parsleyId = 'multiple-' + this.$element.data('parsley-multiple');
                }

                this.$element.attr({
                    'aria-invalid': "true",
                    'aria-describedby': 'parsley-id-' + parsleyId
                });
            });

            $form.parsley().on('field:success', function () {
                this.$element.removeAttr('aria-invalid aria-describedby');
            });
        });


    });

};

app.modules.parsley.options = {
    successClass: 'has-success',
    errorClass: 'has-error',
    classHandler: function (_el) {
        return _el.$element.closest('.form-group').find('.form-errors');
    },
    errorsContainer: function (_el) {
        var errorContainer = _el.$element.closest('.form-group').find('.form-errors');
        if (errorContainer && errorContainer.length > 0) {
            return errorContainer;
        }
    },
    // nur felder validieren die sichtbar sind
    excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden"
};

(function () {
    var promise;

    app.loadParsley = function () {
        if (promise) {
            return promise;
        }

        promise = $.Deferred();

        $.loadScript("/static/build/js/libs/parsley.min.js").done(function () {
            if (_cfg.language && _cfg.language !== 'en') {
                if (_cfg.language == 'pt') {
                    _cfg.language = 'pt-pt';
                }
                $.loadScript("/static/build/js/libs/i18n/parsley/" + _cfg.language + ".js").done(function () {
                    promise.resolve();
                }).fail(function () {
                    /*fallback if there is no package*/
                    promise.resolve();
                });
            } else {
                promise.resolve();
            }
        }).fail(function () {
            promise.reject();
        });

        return promise;
    };
}());

app.modules.iframeResizer = function ($scope) {
    $.loadScript("/static/build/js/libs/iframeResizer.min.js").done(function () {
        setTimeout(function () {
            iFrameResize();
        }, 250);
    }).fail(function () {
        console.log('iframeResizer failed');
    });
};

app.modules.eurolandIframeResizer = function ($scope) {
    $.loadScript("https://tools.eurolandir.com/tools/common/eurolandiframeautoheight/eurolandtoolsintegrationobject.js").done(function () {
        setTimeout(function () {
            $('.EurolandToolClass').EurolandIFrameAutoHeight();
        }, 250);
    }).fail(function () {
        console.log('iframeResizer failed');
    });
};

app.iframeBridgeChild = function () {
    // post height on init
    postHeight();

    window.addEventListener('message', function (msg) {
        if (msg.data === "getHeight") {
            postHeight();
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        postHeight();
    }, false);

    window.addEventListener('resize', function () {
        postHeight();
    });

    // also post message when body height changes (due to ajax requests etc)
    onElementHeightChange(document.body, function () {
        postHeight();
    });

    function getHeight() {
        var body = document.body,
            html = document.documentElement;

        var height = Math.max(
            body.offsetHeight,
            html.offsetHeight
        );

        if (height === 0) {
            // this is needed for IE because the other values are not supported
            // the body.scrollHeight must not be included on other devices (ie iOs) because it is equal to the set
            // height of the iframe and does not represent the actual height of the content
            height = body.scrollHeight;
        }

        return height;
    }

    function postHeight() {
        parent.postMessage({'height': getHeight()}, '*');
    }

    function onElementHeightChange(elm, callback) {
        var lastHeight = getHeight(),
            newHeight;

        setTimeout(run, 200);

        function run() {
            newHeight = getHeight();
            if (lastHeight != newHeight) {
                callback();
            }
            lastHeight = newHeight;

            setTimeout(run, 200);
        }
    }
};

app.modules.youtubePlay = function ($scope) {
    var $playBtn = $scope.find('.js-youtube-play');
    $playBtn.each(function (e) {
        var $this = $(this);
        $this.on('click', function (e) {
            e.preventDefault();
            var id = $this.data('youtube-id');
            var image = $this.find('.js-youtube-play__img');
            var play = $this.find('.js-youtube-play__play');
            var video = $this.find('.js-youtube-play__video');
            var iframe = $this.find('iframe');
            var src = 'https://www.youtube-nocookie.com/embed/'+ id +'?rel=0&autoplay=1&mute=1&amp;showinfo=0&amp;modestbranding=1';
            play.remove();
            image.remove();
            video.removeAttr('hidden');
            iframe.attr('src', src);
        });
    });
};

app.modules.autoplayVideo = function ($scope) {
    var $video = $scope.find('.js-autoplay-video');

    $.loadScript('/static/js/libs/jquery.inview.js').done(function () {
        $video.each(function () {
            var $this = $(this);
            $this.one('inview', function (event, isInView) {
                if ($this.data('type') == 'youtube') {
                    var id = $this.data('youtube-id');
                    var image = $this.find('.js-youtube-play__img');
                    var play = $this.find('.js-youtube-play__play');
                    var video = $this.find('.js-youtube-play__video');
                    var iframe = $this.find('iframe');
                    var src = 'https://www.youtube-nocookie.com/embed/'+ id +'?rel=0&autoplay=1&mute=1&amp;showinfo=0&amp;modestbranding=1';
                    play.remove();
                    image.remove();
                    video.removeAttr('hidden');
                    iframe.attr('src', src);
                } else if ($this.data('type') == 'asset') {
                    var assetvideo = $this.find('video');
                    //autoplay asset video
                    assetvideo[0].play();
                }
            });
        });
    });
};

app.modules.animateOnScroll = function ($scope) {

    $.loadScript('/static/build/js/libs/aos.js').done(function () {
        //$scope.find('#mainContent .content-block, #mainContent .highlight-slide').attr('data-aos','fade-up');

        AOS.init({
            once: true
        });

        $(window).on('load', function () {
            AOS.refresh();
        });
    });

};

app.modules.countdown = function ($scope) {
    $.loadScript('/static/build/js/libs/moment.js').done(function () {
        $.loadScript('/static/build/js/libs/moment-timezone-with-data.js').done(function () {
            $.loadScript('/static/build/js/libs/countdown.js').done(function () {
                $scope.find('.js-countdown').each(function () {
                    var countdownDays = $(this).find('.js-countdown__days');
                    var countdownHours = $(this).find('.js-countdown__hours');
                    var countdownMinutes = $(this).find('.js-countdown__minutes');
                    var countdownSeconds = $(this).find('.js-countdown__seconds');

                    var countdownDateString = _config.countdownDate;
                    var countdownDateTimezone = _config.countdownDateTimezone;
                    var countdownDate = moment.tz(countdownDateString,countdownDateTimezone);
                    var deadline = countdownDate.toDate();

                    countdownDays.countdown(deadline, function (event) {
                        countdownDays.html(event.strftime('%D'));
                    });

                    countdownHours.countdown(deadline, function (event) {
                        countdownHours.html(event.strftime('%H'));
                    });

                    countdownMinutes.countdown(deadline, function (event) {
                        countdownMinutes.html(event.strftime('%M'));
                    });

                    countdownSeconds.countdown(deadline, function (event) {
                        countdownSeconds.html(event.strftime('%S'));
                    });
                });
            });
        });
    });
};

app.modules.countUp = function ($scope) {
    $.loadScript('/static/build/js/libs/countUp.min.js').done(function () {
        var language = _config.language;
        var langNrSettings = {'decimal': '.', 'grouping': ','};

        if (language === 'de') {
            langNrSettings['decimal'] = ',';
            langNrSettings['grouping'] = '.';
        }

        var globalOptions = {
            useEasing: true,
            useGrouping: true,
            decimal: langNrSettings['decimal'],
            separator: langNrSettings['grouping']
        };

        $scope.find('.js-countup').each(function (id) {
            var $this = $(this);
            var start = $this.attr('data-countup-start');
            var end = $this.text();
            var decimals = ($this.text() % 1 !== 0) ? 2 : 0;
            var duration = $this.attr('data-countup-duration');

            $this.attr('id', 'js-countup__target-' + id);
            var countUpObj = new CountUp($this.attr('id'), start, end, decimals, duration, globalOptions);

            if (!countUpObj.error) {
                countUpObj.start();
            } else {
                console.error('Execution of countUp failed because of following error[s]:', countUpObj.error);
            }
        });

    });
};

app.modules.autoSubmit = function ($scope) {
    $scope.find('.js-autosubmit-input').on('keyup input', function () {
        $(this).closest('.js-autosubmit-form').submit();
    });
};

app.modules.copyData = function ($scope) {
    $scope.find('.js-copy-data').on('click', function (evt) {
        //get attribute data-copy and copy the value to clipboard
        var copyText = $(this).attr('data-copy');
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(copyText).select();
        document.execCommand("copy");
        $temp.remove();
    });
};

app.modules.showMail = function ($scope) {
    $scope.find('.js-show-mail__btn').on('click', function (evt) {
        var $parent = $(this).closest('.js-show-mail');
        var $mail = $parent.find('.js-show-mail__mail');

        $(this).remove();
        $mail.removeAttr('hidden');
    });
};

app.modules.rangeSlider = function ($scope) {
    $.loadScript("/static/build/js/libs/nouislider.min.js").done(function () {
        $scope.find('.js-range-slider').each(function () {
            var $this = $(this);
            var sliderElement = $this.find('.js-range-slider__slider')[0];
            var min = $this.data('min-value') || 0;
            var max = $this.data('max-value') || 100;
            var minInput = $this.find('.js-range-slider__min');
            var maxInput = $this.find('.js-range-slider__max');
            var decimalPlaces = 0;
            var steps = $this.data('steps') || 1;
            var prefix = $this.data('prefix') || '';

            var startMin = min;
            var startMax = max;

            if (minInput.val()) {
                startMin = minInput.val();
            } else {
                startMin = min;
            }
            if (maxInput.val()) {
                startMax = maxInput.val();
            } else {
                startMax = max;
            }

            if ($this.data('steps') < 1) {
                decimalPlaces = $this.data('steps').toString().length - 2;
            }

            noUiSlider.create(sliderElement, {
                range: {
                    'min': [min],
                    'max': [max]
                }
                , start: [startMin, startMax]
                , handles: 3
                , step: steps
            });

            sliderElement.noUiSlider.on('update', function (values, handle) {
                var value = +values[handle];

                if (handle === 0) {
                    minInput.val(value.toFixed(decimalPlaces) + prefix);
                    // minInput.trigger('change');
                } else {
                    maxInput.val(value.toFixed(decimalPlaces) + prefix);
                    // maxInput.trigger('change');
                }
            });

            sliderElement.noUiSlider.on('change', function (values, handle) {
                if (handle === 0) {
                    minInput.trigger('change');
                } else {
                    maxInput.trigger('change');
                }
            });

            minInput.on('programmaticChange', function () {
                var value = minInput.val() || min;

                sliderElement.noUiSlider.set([value, null]);
            });

            maxInput.on('programmaticChange', function () {
                var value = maxInput.val() || max;

                sliderElement.noUiSlider.set([null, value]);
            });
        });
    }).fail(function () {
        console.log('fail');
    });
};

app.modules.multiDropdown = function ($scope) {
    $scope.find('.js-multi-dropdown').each(function () {
        var defaultText = $(this).children().find('.js-multi-dropdown__placeholder').text();

        function changeButtonText($this) {

            var checkedCheckboxes = $this.closest('.dropdown-menu').children()
                .find('input[type=checkbox]:checked')
                .closest('.js-multi-dropdown__checkbox')
                .find('.js-multi-dropdown__checkbox-label');

            var title = $.map(checkedCheckboxes, function (title) {
                return $(title).text();
            }).join(', ');

            var label = $(checkedCheckboxes[0]).text(),
                otherCount = checkedCheckboxes.length - 1;

            if (checkedCheckboxes.length > 1) {
                label = $(checkedCheckboxes[0]).text() + ' + ' + otherCount;
            }

            var $placeholder = $this.closest('.js-multi-dropdown').children().find('.js-multi-dropdown__placeholder');
            if (checkedCheckboxes.length != 0) {
                $placeholder.text(label).attr('title', title);
            } else {
                $placeholder.text(defaultText).attr('title', defaultText);
            }
        }

        $(this).on('change', '.js-multi-dropdown__checkbox', function () {
            changeButtonText($(this));
        });

        changeButtonText($(this).find('.js-multi-dropdown__checkbox'));

        //prevent dropdown close on content click
        $(this).find('.dropdown-menu__content').on('click', function (evt) {
            evt.stopImmediatePropagation();
        });

    });
};

app.filterForm = function () {
    $.loadScript('/static/build/js/filterform.min.js');
};

app.modules.subSelect = function ($scope) {
    $scope.find('.js-sub-select').each(function () {
        var $subSelect = $(this);
        var $observingInputs = $($subSelect.data('depend-on'));
        var url = $subSelect.data('url');
        var $wrapper = $subSelect.closest('.js-sub-select__wrapper');

        var pendingRequest;
        $observingInputs.on('change', function () {
            var currentValue = $subSelect.val();
            $subSelect.attr('disabled', 'disabled');

            if (pendingRequest) {
                pendingRequest.abort();
            }

            pendingRequest = $.ajax(url, {
                data: $observingInputs.serialize(),
                cache: true,
                dataType: 'html'
            }).done(function (data) {
                $subSelect.empty();
                $subSelect.append(data);

                if (!$.trim(data)) {
                    //if the response is blank
                    $wrapper.hide();
                } else {
                    $wrapper.show();
                    $subSelect.val(currentValue);
                    if (!$subSelect.val()) {
                        $subSelect.val($subSelect.find('option:first-child').val());
                    }
                }
            }).always(function () {
                pendingRequest = null;
                $subSelect.attr('disabled', null);
            });
        });
    });
};

app.modules.collapseCheckbox = function ($scope) {
    $scope.find('.js-collapse-checkbox').on('change', 'input', function (evt) {
        var $target = $($(this).closest('.js-collapse-checkbox').data('target'));

        if ($(this).is(':checked')) {
            $target.collapse('show');
        } else {
            $target.collapse('hide');
        }
    });
};

app.modules.offScreenFilter = function ($scope) {
    if (matchMedia('(max-width: 767px)').matches) {
        $scope.find('.js-open-offscreen').on('click', function (evt) {
            evt.preventDefault();

            var $this = $(this);
            var $target = $($this.attr('href'));

            if (!$target.hasClass('is-open')) {
                $target.addClass('is-open');
            } else {
                $target.removeClass('is-open');
            }
        });

        $scope.find('.js-toggle-filter-level').on('click', function (evt) {
            evt.preventDefault();
            var filterLevel = $(this).closest('li');

            if (!filterLevel.hasClass('is-open')) {
                filterLevel.addClass('is-open')
            } else {
                filterLevel.removeClass('is-open');
            }
        })
    }
};

app.modules.countryDropdown = function ($scope) {
    $scope.find('.js-country-dropdown__clear-products').on('click', function () {
        localStorage.removeItem('recentlyViewedProducts');
    });

    $scope.find('.js-country-dropdown__toggle').on('click', function (evt) {
        evt.preventDefault();

        $(this).closest('.js-country-dropdown').children('li').each(function () {
            $(this).removeClass('is-active');
            $(this).children('.country-dropdown__sub').attr('aria-expanded', false);
        });

        var dropdown = $(this).next('.country-dropdown__sub'),
            parent = $(this).closest('li');

        if (!parent.hasClass('is-active')) {
            parent.addClass('is-active');
            dropdown.attr('aria-expanded', true);
        } else {
            parent.removeClass('is-active');
            dropdown.attr('aria-expanded', false);
        }
    });
};

app.modules.dsGeolocation = function () {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            $('#dsgeolocation').val(position.coords.latitude + ',' + position.coords.longitude);
        });
    } else {
        $('#dsgeolocation').val('0');
    }
};

app.touchNav = function () {
    if (matchMedia('(max-width: 767px)').matches) {
        return;
    }

    var mainNavItems = $('.navbar .navbar-nav>li'),
        mainNavLinks = $('.navbar .navbar-nav>li>a');

    mainNavLinks.on('click', function (evt) {
        if (window.TouchEvent && evt.originalEvent instanceof TouchEvent) {
            var parent = $(this).parent();

            if (!parent.hasClass('is-open')) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                mainNavItems.removeClass('is-open');
                parent.addClass('is-open');

                $('body').on('click', bodyClickHandler);
            }
        }
    });

    mainNavLinks.on('keydown', function (evt) {
        if (evt.keyCode == 40 || evt.keyCode == 38 || evt.keyCode == 32) {
            evt.preventDefault();
            $(this).parent().addClass('is-open');
            $('body').on('keyup', escKeyHandler);
        } else if (evt.keyCode == 9 && !$(this).parent().hasClass('is-open')) {
            mainNavItems.removeClass('is-open');
            $('body').off('keyup', escKeyHandler);
        }
    });

    function escKeyHandler(evt) {
        if (evt.keyCode == 27) {
            mainNavItems.removeClass('is-open');
            $('body').off('keyup', escKeyHandler);
        }
    }

    function bodyClickHandler(evt) {
        if ($(evt.target).parents('.navbar-nav').length < 1) {
            evt.preventDefault();
            mainNavItems.removeClass('is-open');
            $('body').off('click', bodyClickHandler);
        }
    }
};

app.mobileNav = function () {
    if (matchMedia('(max-width: 767px)').matches) {
        var mobileNavPlaceholder = $('#mobile-nav-placeholder'),
            mobileNav = $('#main-nav').clone();

        mobileNavPlaceholder.replaceWith(mobileNav);

        $('.js-navbar-toggle').on('click', function () {
            var navContainer = $(this).closest('.navbar');

            if (!navContainer.hasClass('is-open')) {
                $('.mobile-nav').addClass('is-open');
                navContainer.addClass('is-open');
                $('html').addClass('has-open-nav');
            } else {
                $('.mobile-nav').removeClass('is-open');
                navContainer.removeClass('is-open');

                $(this).closest('.navbar-header').find('.navbar__search').removeClass('is-open');
                $('html').removeClass('has-open-nav');
            }
        }).on('click', function (evt) {
            evt.preventDefault();
        });

        mobileNav.find('.js-toggle-subnav').on('click', function (evt) {
            evt.preventDefault();
            if ($(this).closest('li').hasClass('is-open')) {
                $(this).closest('li').removeClass('is-open');
                $(this).closest('.mobile-nav__content').removeClass('has-open-subnav');
            } else {
                $(this).closest('ul').children().each(function () {
                    $(this).removeClass('is-open');
                    $(this).closest('.mobile-nav__content').removeClass('has-open-subnav');
                });
                $(this).closest('li').addClass('is-open');
                $(this).closest('.mobile-nav__content').addClass('has-open-subnav');
            }
        });
    }
};

app.mobileSubNav = function () {
    if (matchMedia('(max-width: 767px)').matches) {
        $('#mobile-subnav').on('hidden.bs.dropdown', function () {
            $('body').removeClass('ov-hidden');
        });

        $('#mobile-subnav').on('show.bs.dropdown', function () {
            $('body').addClass('ov-hidden');
        });


        $('.js-subnav-toggle').on('click', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            if ($(this).closest('li').hasClass('is-open')) {
                $(this).closest('li').removeClass('is-open');
            } else {
                $(this).closest('li').addClass('is-open');
            }
        });


        $('.js-subnav-back').on('click', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            $(this).closest('ul').parent().closest('li.is-open').removeClass('is-open');
        });
    }
};

app.toggleSearch = function () {
    $('.js-toggle-search').on('click', function (evt) {
        evt.preventDefault();

        var $target = $($(this).data('target'));

        if (!$target.hasClass('is-open')) {
            $target.attr('aria-expanded', true);
            $('body').on('click', bodyClickHandler);

            $target.addClass('is-open');
            $(this).addClass('is-open');
            $target.find('.js-toggle-search-input').focus();

            if (matchMedia('(max-width: 767px)').matches) {
                $(this).closest('.navbar-main').addClass('is-open');
            }
        } else {
            $target.attr('aria-expanded', false);
            $('body').off('click', bodyClickHandler);

            $target.removeClass('is-open');
            $(this).removeClass('is-open');

            if (matchMedia('(max-width: 767px)').matches) {
                $(this).closest('.navbar-main').removeClass('is-open');
            }
        }
    });

    function bodyClickHandler(evt) {
        if ($(evt.target).parents('.js-toggle-search-container').length < 1) {
            evt.preventDefault();
            $('.navbar__search__form').removeClass('is-open');
            $('.navbar__search__toggle').removeClass('is-open');
            $('body').off('click', bodyClickHandler);
        }
    }
};

app.socialAddThis = function () {
    setTimeout(function () {
        $('body').append($('<script type="text/javascript" src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-58c2ba78e0cdaf77" async="async"></script>'));
    }, 5000);
};

var deepLinkInitialized = false;
var deepLink = false;
var performBussinessAreaStepDone = false;

app.modules.debitorSearch = function ($scope) {

    var latitude = null;
    var longitude = null;
    var chooseproductrange = false;
    var marineversion = _config.marineversion;
    var ba = _config.predefindedBusinessArea;
    var pc = _config.predefindedCountry;

    if (!deepLinkInitialized) {

        if (_config.predefindedCountry) {
            goToStep();
        } else {
            getLocation();
        }
        deepLinkInitialized = true;


        if (ba || pc) {
            deepLink = true;
        }
    }

    //$('#choose_city').val(_config.countryFull);

    function removeParameterFromUrl() {
        var url = window.location.toString();
        if (url.indexOf("?") > 0) {
            var urlWithoutParameters = url.substring(0, url.indexOf("?"));
            window.history.replaceState({}, document.title, urlWithoutParameters);
        }
    }

    //reset predefined businessarea and predefined country (from deeplink)
    function removeDeeplinkConfigs() {
        _config.predefindedBusinessArea = false;
        ba = false;
        _config.predefindedCountry = false;
        pc = false;
    }

    function getLocation() {
        if (navigator.geolocation) {
            $('.js-gotostep').addClass('hidden');

            navigator.geolocation.getCurrentPosition(function (position) {
                latitude = position.coords.latitude;
                longitude = position.coords.longitude;

                if (_config.debitorStep == 1) {
                    if (latitude && longitude) {
                        var pendingRequestAddress;

                        if (pendingRequestAddress) {
                            pendingRequestAddress.abort();
                        }

                        var lang = _config.lang;
                        var updatedLang = lang.replace("-", "_");

                        var ajaxLang = _config.ajaxLangForTranslations;

                        if(updatedLang != ajaxLang) {
                            updatedLang = ajaxLang;
                        }

                        pendingRequestAddress = $.ajax({
                            method: "GET",
                            cache: true,
                            url: "/dealersearch-get-address",
                            data: {
                                language: updatedLang,
                                latitude: latitude,
                                longitude: longitude,
                                marineversion: marineversion
                            }
                        }).done(function (msg) {
                            pendingRequestAddress = null;
                            $('.showgeoerror').css('display', 'none');
                            $('#choose_city').val(msg.address);

                            var pendingRequestStepTwo;

                            if (pendingRequestStepTwo) {
                                pendingRequestStepTwo.abort();
                            }

                            var locationTypeDistribution = false;
                            var locationTypeService = false;

                            if ($('#locationTypeDistribution').prop('checked')) {
                                locationTypeDistribution = true;
                            }

                            if ($('#locationTypeService').prop('checked')) {
                                locationTypeService = true;
                            }

                            pendingRequestStepTwo = $.ajax({
                                method: "GET",
                                cache: true,
                                url: "/dealersearch-step-two",
                                data: {
                                    address: msg.address,
                                    language: updatedLang,
                                    dealerconfig: _config.dealerconfig,
                                    latitude: latitude,
                                    longitude: longitude,
                                    locationTypeService: locationTypeService,
                                    locationTypeDistribution: locationTypeDistribution,
                                    country: msg.country,
                                    isgeocoded: true,
                                    marineversion: marineversion,
                                    predefindedBusinessArea: _config.predefindedBusinessArea,
                                    administrative_area_level_1: $('#administrative_area_level_1').val()
                                }
                            }).done(function (msg) {
                                pendingRequestStepTwo = null;
                                $('#choose_city').attr('data-ispostalcode', msg.isPostalCode);
                                if (msg.error == 'true') {
                                    $('.showgeoerror').css('display', 'block');
                                    $('.js-gotostep').removeClass('hidden');
                                    $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');

                                } else {
                                    $("#step2").html(msg.productrange);
                                    $("#choose_city").val(msg.address);
                                    $("#choose_country").val(msg.countryShort);
                                    $("#administrative_area_level_1").val(msg.administrativeAreaLevel1);
                                    $('.js-gotostep').addClass('hidden');
                                    $("#step2").removeClass("hidden");
                                    app.initModules($("#step2"));


                                    _config.debitorStep = 2;


                                    if (sessionStorage) {
                                        sessionStorage.setItem('geocode', msg.geocode);
                                    }
                                }
                                if (ba) {
                                    $('.js-choose-productrange').val(ba);
                                    performBussinessAreaStep(ba);
                                    performBussinessAreaStepDone = true;
                                }
                            });

                        });
                    }
                }

            }, function error(err) {
                // use geolocation from ip service
                goToStep();
            });
        }
    }

    function handleStepWidth(step, oldStepWidth, stepWidth) {
        $(step).removeClass(oldStepWidth).addClass(stepWidth);
    }

    function resetSearch() {
        var pendingRequest;
        _config.debitorStep = 1;

        $('.js-show-detaillist').css('display', 'none');
        $('.js-finalstep').addClass('hidden');
        $('.js-finalstep').unbind("click");
        if ($('#choose_city').val() == '') {
            $('.js-gotostep').addClass('hidden');
        } else {
            $('.js-gotostep').removeClass('hidden');
        }
        $('.showgeoerror').css('display', 'none');
        $('.moresteps').html('');
        handleStepWidth('#step1', 'step-width-2', 'step-width-4');
        handleStepWidth("#step2", 'step-width-4', 'step-width-2');
        $('#step2').removeClass("has-step-3");
        $(".moresteps:not('#step1')").addClass('hidden');
        $('.js-filter-form-result').html('');
        $('.js-gotostep').text(_config.translateWeiter);
        $('.js-dealersearch-map-image').removeClass("hidden");
        $('.js-google-map').attr('data-infos', '');
        $('#choose_city').attr('data-ispostalcode', '');
        $('.js-ajax__show-dealer-detail__result ').html('');
        if (pendingRequest) {
            pendingRequest.abort();
        }
        performBussinessAreaStepDone = false;
        removeDeeplinkConfigs();


    }


    function goToStep() {
        var isValid;

        var selectedAddress = $('#choose_city').val();
        if (!selectedAddress) {
            var userLocation = sessionStorage.getItem('user_location');
            if (userLocation) {
                userLocation = JSON.parse(userLocation);
                selectedAddress = userLocation.name;
            }
        }

        isValid = true;
        var locationTypeDistribution = false;
        var locationTypeService = false;

        if ($('#locationTypeDistribution').prop('checked')) {
            locationTypeDistribution = true;
        }

        if ($('#locationTypeService').prop('checked')) {
            locationTypeService = true;
        }

        if (isValid) {
            var pendingRequest;

            if (pendingRequest) {
                pendingRequest.abort();
            }

            var lang = _config.lang;
            var updatedLang = lang.replace("-", "_");

            var ajaxLang = _config.ajaxLangForTranslations;

            if(updatedLang != ajaxLang) {
                updatedLang = ajaxLang;
            }

            pendingRequest = $.ajax({
                method: "GET",
                cache: true,
                url: "/dealersearch-step-two",
                data: {
                    address: selectedAddress,
                    language: updatedLang,
                    dealerconfig: _config.dealerconfig,
                    latitude: latitude,
                    longitude: longitude,
                    locationTypeService: locationTypeService,
                    locationTypeDistribution: locationTypeDistribution,
                    isgeocoded: false,
                    marineversion: marineversion,
                    predefindedBusinessArea: ba,
                    administrative_area_level_1: $('#administrative_area_level_1').val()
                }
            }).done(function (msg) {
                pendingRequest = null;

                $('#choose_city').attr('data-ispostalcode', msg.isPostalCode);

                $('.showgeoerror').css('display', 'none');

                if (msg.error == 'true') {
                    $('.showgeoerror').css('display', 'block');
                    $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
                } else {
                    $('.js-finalstep').addClass('hidden');
                    $('.js-gotostep').addClass('hidden');


                    $("#step2").html(msg.productrange);
                    $("#choose_city").val(msg.address);
                    $("#choose_country").val(msg.countryShort);
                    $("#administrative_area_level_1").val(msg.administrativeAreaLevel1);

                    app.initModules($("#step2"));


                    $('#step2').removeClass('hidden');
                    _config.debitorStep = 2;

                    if (sessionStorage) {
                        sessionStorage.setItem('geocode', msg.geocode);
                    }
                    if (ba) {
                        $('.js-choose-productrange').val(ba);
                        performBussinessAreaStep(ba);
                        performBussinessAreaStepDone = true;
                    }

                }

                $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');


            }).fail(function (response, errorType, errorText) {
                $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
            });
        } else {
            $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
            $('.js-finalstep').addClass('hidden');
            $('.js-gotostep').addClass('hidden');
        }
    }

    function companySearch(formadata) {
        var lang = _config.lang;
        var updatedLang = lang.replace("-", "_");

        var ajaxLang = _config.ajaxLangForTranslations;

        if(updatedLang != ajaxLang) {
            updatedLang = ajaxLang;
        }

        var urlList = "/dealersearch/companysearch?" + formadata + "&language=" + updatedLang + "&dealerconfig=" + _config.dealerconfig + '&marineversion=' + marineversion + '&viewData=list';
        var urlMap = "/dealersearch/companysearch?" + formadata + "&language=" + updatedLang + "&dealerconfig=" + _config.dealerconfig + '&marineversion=' + marineversion + '&viewData=map';

        //var urlList = "/dealersearch/companysearch?" + formadata + "&language=" + _config.lang + "&dealerconfig=" + _config.dealerconfig + '&marineversion=' + marineversion + '&viewData=list';
        //var urlMap = "/dealersearch/companysearch?" + formadata + "&language=" + _config.lang + "&dealerconfig=" + _config.dealerconfig + '&marineversion=' + marineversion + '&viewData=map';

        ajaxCompanySearch(urlList, urlMap);

        var country = $('#choose_country').val();
        var company = $('[name="companyname"]').val();

        if (window.dataLayer) {
            dataLayer.push({
                event: "dealerSearchFormSubmit",
                component: "dealer search",
                element: "company search",
                elementName: "",
                elementType: "form",
                clickUrl: "",
                contentName: "",
                position: "",
                department: "sales & service",
                countryCode: country,
                product: {
                    category: "",
                    regionalCategory: ""
                },
                dealer: {
                    dealerName: company
                }
            });
        }
    }

    function validatePLZ() {

        var showSearchBtn = false;
        var plzval = $('#plz').val();

        var re = /(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})/g;
        var str = plzval;
        var myArray = str.match(re);

        if (Array.isArray(myArray)) {
            if (plzval == myArray[0]) {
                showSearchBtn = true;
            } else {
                showSearchBtn = false;
            }
        } else {
            showSearchBtn = false;
        }
        return showSearchBtn;
    }


    $('.js-googlemap-typeahead').off("place_changed").on("place_changed", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!deepLink) {
            goToStep();
        }
    });


    $scope.find('#plz').on('keyup', function (evt) {

        // search for German PLZ

        var showSearchBtn = validatePLZ();

        if (showSearchBtn) {
            $('.js-finalstep').removeClass('hidden');
            $('.showplzerror').css('display', 'none');
            $(document).keypress(function (e) {
                var keycode = (e.keyCode ? e.keyCode : e.which);
                if (keycode == '13') {
                    // enter key
                    $('.js-finalstep').click();
                }
            });
        } else {
            $('.js-finalstep').addClass('hidden');
            $('.showplzerror').css('display', 'block');
            $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');

        }

    });

    $scope.find('.js-get-location').on('click', function (evt) {
        resetSearch();
        getLocation();
    });

    $scope.find('.js-gotostep').on('click', function (evt) {
        evt.preventDefault();


        $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');
        // step 1
        if (_config.debitorStep == 1) {
            goToStep();
            evt.preventDefault();
        }

    });

    $scope.find('.companyname').on('focus', function (evt) {
        var searchForm = $(this).parents('form');

        $(document).keypress(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode == '13') {
                // enter key
                $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');

                var formadata = searchForm.serialize();
                companySearch(formadata);

                e.preventDefault();
                return false;
            }
        });
    });


    $scope.find('.js-gotocompanysearch').on('click', function (evt) {

        // resetSearch();
        $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');

        evt.preventDefault();

        var formadata = $(this).parents('form').serialize();

        companySearch(formadata);


    });

    $scope.find('.city').on('keyup', function (evt) {

        $('.js-show-detaillist').css('display', 'none');
        var field = $(this).val();

        if (field.length > 1) {
            $('.js-gotostep').removeClass('hidden');
        } else {
            $('.js-gotostep').addClass('hidden');
        }

    });

    $scope.find('.city').on('focus', function (evt) {

        // reset
        resetSearch();
        _config.debitorStep = 1;
        evt.preventDefault();

        $(document).keypress(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode == '13') {
                // enter key
                $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');
                // step 1
                if (_config.debitorStep == 1) {
                    e.preventDefault();

                    goToStep();
                }
                return false;
            }
        });
    });

    $scope.find('.js-filter-form__input').on('change', function (evt) {
        if (_config.debitorStep >= 2 && _config.debitorStep != 4) {
            var $productRangeValue = $('.choose_productrange').val();
            if ($productRangeValue != '' && $productRangeValue != null && $productRangeValue != 'undefined') {
                //goToStep();
                performBussinessAreaStep($productRangeValue);
            }
        } else if (_config.debitorStep == 4) {
            evt.preventDefault();
            var showSearchBtn = validatePLZ();

            if (showSearchBtn) {
                $('.js-finalstep').removeClass('hidden');
                $('.showplzerror').css('display', 'none');
                $('.js-finalstep').click();
            }
        }

    });

    $scope.find('.nav-tabs--dealersearch li').on("click", function (evt) {
        resetSearch();
    });

    $scope.find('.js-finalstep').unbind('click').on('click', function (evt) {
        evt.preventDefault();

        var country = $('#choose_country').val();
        var category = $('.js-choose-productrange option:selected').text();
        var categoryGlobal = $('.js-choose-productrange option:selected').attr('data-gtm-dealer-global-category');
        var distribution = $('[data-gtm-dealer-type="distribution"]');
        var service = $('[data-gtm-dealer-type="service"]');
        var predefinedForm = $('[data-gtm-predefined-form="true"]');

        var elementType = "form";
        if (predefinedForm.length) {
            elementType = "predefined form";
        }

        var department = "";

        if (distribution.prop('checked')) {
            department = "sales"
        }
        if (service.prop('checked')) {
            department = "service"
        }
        if ((service.prop('checked') && distribution.prop('checked'))) {
            department = "sales & service"
        }

        if (window.dataLayer) {
            dataLayer.push({
                event: "dealerSearchFormSubmit",
                component: "dealer search",
                element: "location search",
                elementName: "",
                elementType: elementType,
                clickUrl: "",
                contentName: "",
                position: "",
                department: department,
                countryCode: country,
                product: {
                    category: categoryGlobal,
                    regionalCategory: category
                },
                dealer: {
                    dealerName: ""
                }
            });
        }

        $('.js-ajax__show-dealer-detail__result ').html('');
        $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');
        $('.js-dealer-map__loading').attr('hidden', false).removeClass('hidden');

        var geocodelocationtype = null;
        var geocodelat = null;
        var geocodelng = null;
        var newGoogleMap = $('.js-google-map').data('google-map');

        if (sessionStorage) {
            var geocodedata = sessionStorage.getItem('geocode');

            if (geocodedata) {
                var jsondata = JSON.parse(geocodedata);
                jsondata = jsondata[0];

                if (jsondata.geometry.location_type == 'GEOMETRIC_CENTER') {
                    jsondata.geometry.location_type = 'ROOFTOP';
                }

                geocodelocationtype = jsondata.geometry.location_type;
                geocodelat = jsondata.geometry.location.lat;
                geocodelng = jsondata.geometry.location.lng;

            }
        }

        // listview

        var pendingRequest;

        if (pendingRequest) {
            pendingRequest.abort();
        }


        pendingRequest = $.ajax({
            method: "GET",
            cache: true,
            url: "/dealersearch-get-dealer?" + $('#dealersearchform').serialize() + '&marineversion=' + marineversion + '&geocodelocationtype=' + geocodelocationtype + '&geocodelat=' + geocodelat + '&geocodelng=' + geocodelng + '&viewData=list'
        }).done(function (msg) {

            $('.js-show-detaillist').css('display', 'block');
            var filterFormResult = $('.js-filter-form-result');
            filterFormResult.html(msg.template);

            $('.js-dealersearch-map-image').addClass("hidden");
            app.initModules(filterFormResult);
            $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');


            if (ba || pc) {

                $('html, body').stop().animate({
                        scrollTop: $('.js-show-detaillist').offset().top - 50
                    },
                    500,
                    'swing'
                );

            }

            if (deepLinkInitialized) {
                deepLink = true;
                removeParameterFromUrl();
            }
            pendingRequest = null;
        });

        // mapview
        var pendingRequestMap;

        if (pendingRequestMap) {
            pendingRequestMap.abort();
        }

        pendingRequestMap = $.ajax({
            method: "GET",
            cache: true,
            url: "/dealersearch-get-dealer?" + $('#dealersearchform').serialize() + '&marineversion=' + marineversion + '&geocodelocationtype=' + geocodelocationtype + '&geocodelat=' + geocodelat + '&geocodelng=' + geocodelng + '&viewData=map'
        }).done(function (msg) {

            if (msg.mapdata == false) {
                $('.js-dealer-map__loading').attr('hidden', true).addClass('hidden');
                $('.js-dealer-items-count').text('0');
                $('.js-dealersearch-map-image').addClass('hidden');
                return;
            }
            var dealerMap = JSON.parse(msg.mapdata);
            var dealer = dealerMap.dealer;
            var dealerInfos = dealerMap.info;
            var dealernumber = dealerInfos.numberofdealer;
            var dealerInfosLocationType = dealerInfos.geocodelocationtype;

            $('.js-dealer-items-count').text(dealernumber);

            var latitude = dealerInfos.geocodelat;
            var longitude = dealerInfos.geocodelng;

            $('.js-google-map').attr('data-infos', dealerInfosLocationType);

            if (typeof dealerInfosLocationType != 'undefined' && dealerInfosLocationType == 'ROOFTOP') {

                var myPos = {
                    id: 'myLocationMarker',
                    lat: latitude,
                    lng: longitude,
                    poiIcon: "/static/build/img/map/current_position_poi.png"
                }
                dealer.push(myPos);
            }
            newGoogleMap.setMarker(dealer);
            newGoogleMap.initTab();

            $('.js-dealersearch-map-image').addClass("hidden");

            google.maps.event.trigger(newGoogleMap.map, 'resize');
            newGoogleMap.centerMap();


            $('.js-dealer-map__loading').attr('hidden', true).addClass('hidden');

            pendingRequestMap = null;
        });


    });

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // paginglinks
    $scope.find('.js-isAjax').on('click', function (evt) {

        evt.preventDefault();
        $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');

        var href = $(this).attr('href');

        $.ajax({
            method: "GET",
            url: href
        }).done(function (msg) {
            var filterFormResult = $('.js-filter-form-result');
            filterFormResult.html(msg.template);
            app.initModules(filterFormResult);
            $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
        });

    });

    function showPlzStep(msg) {

        var postalCode = $('#choose_city').attr('data-ispostalcode');
        var plzInputVal = $('.js-plz-input').val();


        if (msg != false) {
            if (!plzInputVal && plzInputVal != '' && plzInputVal != 'undefined') {
                $("#step4").removeClass("hidden");
                $("#step4").html(msg);
                app.initModules($("#step4"));
                handleStepWidth("#step1", 'step-width-4', 'step-width-2');
                $('.js-finalstep').addClass('hidden');
            }
            _config.debitorStep = 4;
            if (postalCode || validatePLZ(plzInputVal)) {
                if (postalCode) {
                    $('.js-plz-input').val(postalCode);
                }
                $('.js-gotostep').removeClass('hidden');
                $('.js-finalstep').removeClass('hidden');
            }

        } else {
            $('.js-finalstep').removeClass('hidden');
            $("#step4").addClass("hidden");
            $("#step4").html('');
            $('.js-gotostep').removeClass('hidden');
            $('.js-finalstep').removeClass('hidden');
        }


        $('.js-gotostep').addClass('hidden');


        if (ba || pc) {
            setTimeout(function () {
                var ba = _config.predefindedBusinessArea;

                /*
                    if predefinde country is germany plz input is required by the user
                 */

                if (pc != 'DE') {
                    $('.js-finalstep').click();
                    $('.js-finalstep').removeClass('hidden');
                }


            }, 300);
        }
    }

    function performBussinessAreaStep(baVal, reset) {
        $('.js-show-detaillist').css('display', 'none');
        $('.js-filter-form-loading').attr('hidden', null).removeClass('hidden');
        $('.js-dealersearch-map-image').removeClass("hidden");


        var productgroupSelected = false;
        var showPlzField = false;
        if ($('#locationTypeDistribution').prop('checked')) {
            showPlzField = true;
        }

        var locationTypeDistribution = false;
        var locationTypeService = false;

        if ($('#locationTypeDistribution').prop('checked')) {
            locationTypeDistribution = true;
        }

        if ($('#locationTypeService').prop('checked')) {
            locationTypeService = true;
        }

        var pendingRequest;

        if (pendingRequest) {
            pendingRequest.abort();
        }

        var selCountry = $('#choose_country').val();
        if (pc) {
            selCountry = pc;
        }


        if (locationTypeDistribution || locationTypeService && baVal != ' ') {

            var lang = _config.lang;
            var updatedLang = lang.replace("-", "_");

            var ajaxLang = _config.ajaxLangForTranslations;

            if(updatedLang != ajaxLang) {
                updatedLang = ajaxLang;
            }

            pendingRequest = $.ajax({
                method: "GET",
                cache: true,
                url: "/dealersearch-get-productgroups",
                data: {
                    language: updatedLang,
                    businessarea: baVal,
                    country: selCountry,
                    showPlzField: showPlzField,
                    marineversion: marineversion,
                    locationTypeDistribution: locationTypeDistribution,
                    locationTypeService: locationTypeService,
                    administrative_area_level_1: $('#administrative_area_level_1').val()
                }
            }).done(function (msg) {

                pendingRequest = null;

                $("#step3").html(msg.template);
                handleStepWidth("#step1", 'step-width-4', 'step-width-2');
                app.initModules($("#step3"));


                if (msg.template != false) {
                    handleStepWidth("#step2", 'step-width-2', 'step-width-4');
                    $('#step2').addClass("has-step-3");
                    $('.js-finalstep').addClass('hidden');
                    $scope.find('#choose_productgroup').on('change', function (evt) {
                        productgroupSelected = true;
                        showPlzStep(msg.showPlz);
                    });

                } else {
                    $('#step2').removeClass("has-step-3");
                    handleStepWidth("#step1", 'step-width-2', 'step-width-4');
                    handleStepWidth("#step2", 'step-width-4', 'step-width-2');
                    if (msg.showPlz) {
                        showPlzStep(msg.showPlz);
                    } else {
                        if (ba && pc == 'DE') {
                            $('.js-finalstep').click();
                        }
                    }
                }


                if ($('#step3').is(':empty') || (msg.distributionMandatory != true)) {
                    showPlzStep(msg.showPlz);
                }


                app.initModules($('.js-srcbutton'));
                $('.js-finalstep').prop('disabled', false);

                $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');

                if (ba) {
                    $('.js-choose-productrange').val(ba);
                }


            });
        } else {
            $('.js-finalstep').prop('disabled', true);
            $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');

        }


    }


    $scope.find('.choose_productrange').on('change', function (evt) {
        //reset predefined businessarea (from deeplink)
        if (deepLinkInitialized) {
            _config.predefindedBusinessArea = false;
            ba = false;
            performBussinessAreaStepDone = false;
        }
        performBussinessAreaStep($(this).val());
    });


};

function ajaxCompanySearch(urlList, urlMap) {
    $.ajax({
        method: "GET",
        cache: true,
        url: urlList
    }).done(function (msg) {

        $('.js-show-detaillist').css('display', 'block');
        var filterFormResult = $('.js-filter-form-result');
        filterFormResult.html(msg.template);
        $('#dealermap').attr('data-map-poi', msg.mapdata);
        app.initModules(filterFormResult);
        $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');


    }).fail(function (response, errorType, errorText) {
        console.error('Companysearch error', +response, errorType, errorText);
        $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
    });

    $.ajax({
        method: "GET",
        cache: true,
        url: urlMap
    }).done(function (msg) {
        if(msg.mapdata) {
            var dealerMap = JSON.parse(msg.mapdata);

            var dealer = dealerMap.dealer;
            var dealerInfos = dealerMap.info;
            var dealernumber = dealerInfos.numberofdealer;

            $('.js-dealer-items-count').text(dealernumber);

            var newGoogleMap = $('.js-google-map').data('google-map');
            $('.js-google-map').attr('data-infos', '');
            $('.js-dealersearch-map-image').addClass('hidden');
            $('.js-dealer-map__loading').attr('hidden', true).addClass('hidden');

            newGoogleMap.setMarker(dealer);
            newGoogleMap.initTab();
        }

    }).fail(function (response, errorType, errorText) {
        console.error('Companysearch error', +response, errorType, errorText);
        $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
        $('.js-dealer-map__loading').attr('hidden', true).addClass('hidden');

    });
}

app.modules.reloadForm = function ($scope) {
    $scope.find('.js-reload-form').on('change', function (evt) {
        evt.preventDefault();
        var $this = $($(this).data('target')),
            url = $(this).data('form-url');

        $.ajax(url, {
            data: $(this).serialize(),
            cache: true,
            dataType: 'html'
        }).done(function (data) {
            $this.html(data);
            app.initModules($this);
        });
    });
};

app.modules.preventModal = function ($scope) {
    $scope.find('.js-prevent-modal').on('click', function (e) {
        e.stopImmediatePropagation();
    });
};

app.modules.quiz = function ($scope) {
    $scope.find('.js-quiz__answer').on('click', function (e) {
        var $quiz = $(this).closest('.js-quiz');
        var $quizBtns = $(this).closest('.js-quiz').find('.js-quiz__answer');

        $quiz.addClass('quiz-element--completed');

        if($(this).hasClass('js-quiz__answer--right')) {
            $(this).addClass('is-answered-right');
        } else {
            $(this).addClass('is-answered-false');
        }

    });
};

app.modules.requestForm = function ($scope) {
    /* download modal specific stuff */
    var $additionalDownloadText;
    $('#download-modal').on('shown.bs.modal', function (e) {
        e.stopImmediatePropagation();
        $additionalDownloadText = $(this).find('.product-modal__info').find('.wysiwyg');
        app.formbuilder();
    });

    $('#download-modal').on('hidden.bs.modal', function (e) {
        /*show form on modal close*/
        e.preventDefault();
        e.stopImmediatePropagation();
        $(this).find('.js-request-form__success').attr('hidden', 'hidden');
        $(this).find('.js-request-form__form').removeAttr('hidden');
        $additionalDownloadText.removeAttr('hidden');
    });

    $('.js-product-modal-tracking').on('hidden.bs.modal', function (e) {
        var modalId = $(this).attr('id');
        var $modal = $('#'+modalId);

        /*contact form tracking on modal close*/
        e.preventDefault();
        e.stopImmediatePropagation();

        $modal.find('.js-request-form__success').attr('hidden', 'hidden');
        $modal.find('.js-request-form__form').removeAttr('hidden');

        var component = "";
        //check if component is in sessionstorage (set via click tracking)
        if(sessionStorage.getItem('component')) {
            component = sessionStorage.getItem('component');
        }

        var type = "product modal form";
        //var department = $modal.find('.js-request-form__form').find('#form_trackingDepartment').val() ? $modal.find('.js-request-form__form').find('#form_trackingDepartment').val() : undefined;
        //var purpose = $modal.find('.js-request-form__form').find('#form_trackingPurpose').val() ? $modal.find('.js-request-form__form').find('#form_trackingPurpose').val() : undefined;

        var trackingDepartment = $modal.find('.js-request-form__form').find('.form_trackingDepartment').val() ? $modal.find('.js-request-form__form').find('.form_trackingDepartment').val() : undefined;
        var trackingPurpose = $modal.find('.js-request-form__form').find('.form_trackingPurpose').val() ? $modal.find('.js-request-form__form').find('.form_trackingPurpose').val() : undefined;
        var trackingSubmissionId = $modal.find("input[name*='trackingSubmissionId']").val();

        //check if modal is a download-modal
        if (modalId.startsWith('download-modal-') || modalId.startsWith('download_modal_')) {
            component = "download teaser";
            type = "product modal form download";
            trackingDepartment = undefined;
            trackingPurpose = "download request"
        }

        if($additionaltext) {
            $additionaltext.removeAttr('hidden');
        }

        if ($modal.hasClass('successfully-submitted')) {
            if (window.dataLayer) {

                var contactFormExitEvent = {
                    'event': 'contactFormExit',
                    'component': component,
                    'contactForm': {
                        'type': type,
                        'display': 'modal',
                        'title': $modal.find('.js-request-form__form').attr('data-title'),
                        'inputFieldCount': $modal.find('.js-request-form__form').attr('data-inputs'),
                        'department': trackingDepartment,
                        'purpose': trackingPurpose,
                        'submissionId': undefined
                    }
                };

                /*
                dataLayer.push({
                    'event': 'contactFormExit',
                    'component': component,
                    'contactForm': {
                        'type': type,
                        'display': 'modal',
                        'title': $modal.find('.js-request-form__form').attr('data-title'),
                        'inputFieldCount': $modal.find('.js-request-form__form').attr('data-inputs'),
                        'department': department,
                        'purpose': purpose,
                        'submissionId': submissionId
                    }
                });
                 */

                //console.log(contactFormExitEvent);

                dataLayer.push(contactFormExitEvent);
            }
        } else {
            if (window.dataLayer) {

                var contactFormAbandonEvent = {
                    'event': 'contactFormAbandon',
                    'component': component,
                    'contactForm': {
                        'type': type,
                        'display': 'modal',
                        'title': $modal.find('.js-request-form__form').attr('data-title'),
                        'inputFieldCount': $modal.find('.js-request-form__form').attr('data-inputs'),
                        'department': trackingDepartment,
                        'purpose': trackingPurpose,
                        'submissionId': undefined
                    }
                };

                /*
                dataLayer.push({
                    'event': 'contactFormAbandon',
                    'component': component,
                    'contactForm': {
                        'type': type,
                        'display': 'modal',
                        'title': $modal.find('.js-request-form__form').attr('data-title'),
                        'inputFieldCount': $modal.find('.js-request-form__form').attr('data-inputs'),
                        'department': department,
                        'purpose': purpose,
                        'submissionId': submissionId
                    }
                });
                 */

                //console.log(contactFormAbandonEvent);

                dataLayer.push(contactFormAbandonEvent);
            }
        }
    });

    var $additionaltext;

    if($('.js-product-modal-tracking').length) {
        //change input classes for tracking
        $('.js-product-modal-tracking').each(function() {

            // add a custom class name to form elements
            $(this).find('.form-control').each(function(index) {
                var formNameArray = $(this).attr('name').split(/[[\]]{1,2}/);

                if(formNameArray.slice(-1) == '') {
                    formNameArray.pop();
                }
                var formName = formNameArray.slice(-1);

                if(formName[0]) {
                    formName = formName[0];
                }

                $(this).addClass('form_'+formName);
            });
        });
    }


    $('.js-product-modal-tracking').on('shown.bs.modal', function (e) {
        var modalId = $(this).attr('id');
        var $modal = $('#'+modalId);

        /*contact form tracking on modal open*/
        e.stopImmediatePropagation();
        /* set data attributes for tracking */
        var inputCount = $modal.find('input:not(:hidden)').length;
        var textareaCount = $modal.find('textarea:not(:hidden)').length;
        var checkboxCount = $modal.find('input:checkbox').length;

        $modal.find('.js-request-form__form').attr('data-inputs', inputCount + textareaCount + checkboxCount);
        $modal.find('.js-request-form__form').attr('data-title', $modal.find('.product-modal__title').text());

        var component = "";
        //check if component is in sessionstorage (set via click tracking)
        if(sessionStorage.getItem('component')) {
            component = sessionStorage.getItem('component');
        }

        var type = "product modal form";
        //var department = $modal.find('.js-request-form__form').find('#form_trackingDepartment').val() ? $modal.find('.js-request-form__form').find('#form_trackingDepartment').val() : undefined;
        //var purpose = $modal.find('.js-request-form__form').find('#form_trackingPurpose').val() ? $modal.find('.js-request-form__form').find('#form_trackingPurpose').val() : undefined;

        var trackingDepartment = $modal.find('.js-request-form__form').find('.form_trackingDepartment').val() ? $modal.find('.js-request-form__form').find('.form_trackingDepartment').val() : undefined;
        var trackingPurpose = $modal.find('.js-request-form__form').find('.form_trackingPurpose').val() ? $modal.find('.js-request-form__form').find('.form_trackingPurpose').val() : undefined;

        //check if modal is a download-modal

        if (modalId.startsWith('download-modal-') || modalId.startsWith('download_modal_')) {
            component = "download teaser";
            type = "product modal form download";
            trackingDepartment = undefined;
            trackingPurpose = "download request"
        }

        if (window.dataLayer) {
            var contactFormOpenedEvent = {
                'event': 'contactFormOpened',
                'component': component,
                'contactForm': {
                    'type': type,
                    'display': 'modal',
                    'title': $modal.find('.js-request-form__form').attr('data-title'),
                    'inputFieldCount': $modal.find('.js-request-form__form').attr('data-inputs'),
                    'department': trackingDepartment,
                    'purpose': trackingPurpose,
                    'submissionId': undefined
                }
            };

            /*
            dataLayer.push({
                'event': 'contactFormOpened',
                'component': component,
                'contactForm': {
                    'type': type,
                    'display': 'modal',
                    'title': $modal.find('.js-request-form__form').attr('data-title'),
                    'inputFieldCount': $modal.find('.js-request-form__form').attr('data-inputs'),
                    'department': department,
                    'purpose': purpose,
                    'submissionId': undefined
                }
            });
            */

            //console.log(contactFormOpenedEvent);

            dataLayer.push(contactFormOpenedEvent);
        }

        $additionaltext = $modal.find('.product-modal__info').find('.wysiwyg');
        app.formbuilder();
    });

    /*contact form tracking on input change*/
    $scope.find('.js-product-modal-tracking .js-request-form__form input, .js-product-modal-tracking .js-request-form__form textarea').on('focus', function () {
        if (!$(this).closest('.js-request-form__form').hasClass('was-changed')) {

            var $modal = $(this).closest('.js-product-modal-tracking');
            var modalId = $modal.attr('id');

            var component = "";
            //check if component is in sessionstorage (set via click tracking)
            if(sessionStorage.getItem('component')) {
                component = sessionStorage.getItem('component');
            }

            var type = "product modal form";
            var department = $(this).closest('.js-request-form__form').find('#form_trackingDepartment').val() ? $(this).closest('.js-request-form__form').find('#form_trackingDepartment').val() : undefined;
            var purpose = $(this).closest('.js-request-form__form').find('#form_trackingPurpose').val() ? $(this).closest('.js-request-form__form').find('#form_trackingPurpose').val() : undefined;

            var trackingDepartment = $(this).closest('.js-request-form__form').find('.form_trackingDepartment').val() ? $(this).closest('.js-request-form__form').find('.form_trackingDepartment').val() : undefined;
            var trackingPurpose = $(this).closest('.js-request-form__form').find('.form_trackingPurpose').val() ? $(this).closest('.js-request-form__form').find('.form_trackingPurpose').val() : undefined;


            //check if modal is a download-modal
            if (modalId.startsWith('download-modal-') || modalId.startsWith('download_modal_')) {
                component = "download teaser";
                type = "product modal form download";
                trackingDepartment = undefined;
                trackingPurpose = "download request"
            }

            if (window.dataLayer) {

                var contactFormStartEvent = {
                    'event': 'contactFormStart',
                    'component': component,
                    'contactForm': {
                        'type': type,
                        'display': 'modal',
                        'title': $(this).closest('.js-request-form__form').attr('data-title'),
                        'inputFieldCount': $(this).closest('.js-request-form__form').attr('data-inputs'),
                        'department': trackingDepartment,
                        'purpose': trackingPurpose,
                        'submissionId': undefined,
                    }
                };


                /*
                dataLayer.push({
                    'event': 'contactFormStart',
                    'component': component,
                    'contactForm': {
                        'type': type,
                        'display': 'modal',
                        'title': $(this).closest('.js-request-form__form').attr('data-title'),
                        'inputFieldCount': $(this).closest('.js-request-form__form').attr('data-inputs'),
                        'department': department,
                        'purpose': purpose,
                        'submissionId': undefined,
                    }
                });
                */

                //console.log(contactFormStartEvent);

                dataLayer.push(contactFormStartEvent);
            }
        }
        $(this).closest('.js-request-form__form').addClass('was-changed');
    });

    $scope.find('.js-request-form__form').on('submit', function (evt) {
        evt.preventDefault();

        var $modal = $(this).closest('.js-product-modal-tracking');
        var modalId = $modal.attr('id');

        var url = $(this).attr('action');
        var method = $(this).attr('method');
        var $successMessage = $(this).closest('.js-request-form').find('.js-request-form__success');
        var $errorMessage = $(this).closest('.js-request-form').find('.js-request-form__error');
        var $this = $(this);
        var trackingType = "product modal form";
        var trackingComponent = "";
        //check if component is in sessionstorage (set via click tracking)
        if(sessionStorage.getItem('component')) {
            trackingComponent = sessionStorage.getItem('component');
        }
        var trackingDepartment = $(this).closest('.js-request-form__form').find('.form_trackingDepartment').val() ? $(this).closest('.js-request-form__form').find('.form_trackingDepartment').val() : undefined;
        var trackingPurpose = $(this).closest('.js-request-form__form').find('.form_trackingPurpose').val() ? $(this).closest('.js-request-form__form').find('.form_trackingPurpose').val() : undefined;
        var trackingSubmissionId = $(this).closest('.js-request-form__form').find("input[name*='trackingSubmissionId']").val();
        var productCategory = null;

        if($(this).closest('.js-request-form__form').find('.form_Department').length > 0 && $(this).closest('.js-request-form__form').find('.form_Department').val() != '') {
            trackingDepartment = $(this).closest('.js-request-form__form').find('.form_Department').val();
        }
        if($(this).closest('.js-request-form__form').find('.form_Purpose').length > 0 && $(this).closest('.js-request-form__form').find('.form_Purpose').val() != '') {
            trackingPurpose = $(this).closest('.js-request-form__form').find('.form_Purpose').val();
        }
        if($(this).closest('.js-request-form__form').find('.form_ProductCategory').length > 0 && $(this).closest('.js-request-form__form').find('.form_ProductCategory').val() != '') {
            productCategory = $(this).closest('.js-request-form__form').find('.form_ProductCategory').val();
        }

        // use internalname attribute if field is a optionSelect
        if($(this).closest('.js-request-form__form').find('.form_optionSelect').length > 0) {
            var $optionSelects = $(this).closest('.js-request-form__form').find('.form_optionSelect');

            $optionSelects.each(function() {
                var internalName = this.getAttribute('internalname');
                if(internalName && internalName == 'Department' && this.value) {
                    trackingDepartment = this.value;
                }
                if(internalName && internalName == 'Purpose' && this.value) {
                    trackingPurpose = this.value;
                }
                if(internalName && internalName == 'ProductCategory' && this.value) {
                    productCategory = this.value;
                }
            });
        }

        //check if modal is a download-modal
        if (modalId.startsWith('download-modal-') || modalId.startsWith('download_modal_')) {
            trackingComponent = "download teaser";
            trackingType = "product modal form download";
            trackingDepartment = undefined;
            trackingPurpose = "download request"
        }

        if ($this.data('Parsley') && $this.data('Parsley').isValid() || !$this.data('Parsley')) {
            var $submitBtn = $this.find('button[type="submit"]');

            // disable submit button to prevent double submission
            $submitBtn.attr('disabled', true);

            grecaptcha.ready(function () {
                grecaptcha.execute(_config.googleRecaptchasiteKey, {action: 'homepage'}).then(function (token) {
                    var $recaptchaResponseInput = $this.find('input[name="form\[googleRecaptcha\]"]');
                    $recaptchaResponseInput.val(token);

                    var formdata = $this.serialize();

                    $.ajax(url, {
                        data: formdata,
                        method: method,
                        dataType: 'json'
                    }).done(function (data) {
                        if (data.success == true) {
                            $this.attr('hidden', 'hidden');
                            $errorMessage.attr('hidden', 'hidden');
                            $successMessage.removeAttr('hidden');

                            $(this).closest($('.js-product-modal-tracking').addClass('successfully-submitted'));

                            if (data.downloadUrl) {
                                if (window.dataLayer) {
                                    /* file download tracking */
                                    /*
                                    dataLayer.push({
                                        event: "fileDownload",
                                        component: "download teaser",
                                        element: "document",
                                        elementName: "download",
                                        elementType: data.downloadType,
                                        elementId: data.downloadId,
                                        clickUrl: window.location.protocol + '//' + window.location.hostname + data.downloadUrl,
                                        contentName: data.downloadTitle,
                                        position: "modal form"
                                    });
                                     */

                                    var clickUrl = data.downloadUrl;
                                    if(!clickUrl.startsWith('https:')) {
                                        clickUrl = window.location.protocol + '//' + window.location.hostname + data.downloadUrl;
                                    }

                                    var fileDownloadEvent = {
                                        event: "fileDownload",
                                        component: "download teaser",
                                        element: "document",
                                        elementName: "download",
                                        elementType: data.downloadType,
                                        elementId: data.downloadId,
                                        clickUrl: clickUrl,
                                        contentName: data.downloadTitle,
                                        position: "modal form"
                                    };

                                    var contactFormSuccessDownloadEvent = {
                                        'event': 'contactFormSuccess',
                                        'component': "download teaser",
                                        'contactForm': {
                                            'type': "product modal form download",
                                            'display': 'modal',
                                            'title': $this.attr('data-title'),
                                            'inputFieldCount': $this.attr('data-inputs'),
                                            'department': undefined,
                                            'purpose': "download request",
                                            'submissionId': trackingSubmissionId
                                        }
                                    };


                                    //console.log(fileDownloadEvent);
                                    //console.log(contactFormSuccessDownloadEvent);

                                    dataLayer.push(fileDownloadEvent);
                                    dataLayer.push(contactFormSuccessDownloadEvent);

                                }
                                setTimeout(function () {
                                    window.open(data.downloadUrl, '_blank');
                                }, 250);
                            } else {
                                if (window.dataLayer) {
                                    /* contactform tracking */
                                    /*
                                    var pushData = {
                                        'event': 'contactFormSuccess',
                                        'contactForm': {
                                            'type': 'product modal form',
                                            'display': 'modal',
                                            'title': $this.attr('data-title'),
                                            'inputFieldCount': $this.attr('data-inputs'),
                                            'department': trackingDepartment,
                                            'purpose': trackingPurpose,
                                            'submissionId': trackingSubmissionId
                                        }
                                    };
                                    */

                                    var contactFormSuccessEvent = {
                                        'event': 'contactFormSuccess',
                                        'component': trackingComponent,
                                        'contactForm': {
                                            'type': trackingType,
                                            'display': 'modal',
                                            'title': $this.attr('data-title'),
                                            'inputFieldCount': $this.attr('data-inputs'),
                                            'department': trackingDepartment,
                                            'purpose': trackingPurpose,
                                            'submissionId': trackingSubmissionId
                                        }
                                    };

                                    if(productCategory) {
                                        contactFormSuccessEvent.product = {
                                            'category': productCategory
                                        };
                                    }

                                    //console.log(contactFormSuccessEvent);

                                    dataLayer.push(contactFormSuccessEvent);

                                    /*
                                    var pushData = {
                                        'type': 'product modal form',
                                        'display': 'modal',
                                        'title': $this.attr('data-title'),
                                        'inputFieldCount': $this.attr('data-inputs'),
                                        'department': trackingDepartment,
                                        'purpose': trackingPurpose,
                                        'submissionId': trackingSubmissionId
                                    };

                                    dataLayer.push({
                                        'event': 'contactFormSuccess',
                                        'contactForm': pushData
                                    });
                                    */


                                    //console.log(pushData);
                                }
                            }

                        } else {
                            var $error = $(this).closest('.js-request-form').find('.js-request-form__error');
                            $errorMessage.removeAttr('hidden');
                        }
                        if ($additionaltext) {
                            $additionaltext.attr('hidden', 'hidden');
                        }
                        // enable submit button again
                        $submitBtn.attr('disabled', false);

                    });
                });
            });
        }
    });
}


app.googleMap = (function () {
    var apiLoaded = false,
        apiLoading = false,
        callbacks = [];

    function loadScript() {
        apiLoading = true;
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (_cfg.googleMapAPIKey) {
            script.src = "https://maps.googleapis.com/maps/api/js?key=" + _cfg.googleMapAPIKey + "&callback=app.googleMap.apiLoadedCallback&libraries=places&language=" + _config.language;
        } else {
            console.log("google maps API key is missing")
        }
        document.body.appendChild(script);
    }

    function apiLoadedCallback() {
        for (var i = 0, callback; callback = callbacks[i]; i++) {
            callback();
        }

        apiLoading = false;
        apiLoaded = true;
    }

    function loadApi(callback) {
        if (apiLoaded) {
            callback();
        } else {
            callbacks.push(callback);

            if (!apiLoading) {
                loadScript();
            }
        }
    }

    return {
        apiLoadedCallback: apiLoadedCallback,
        loadApi: loadApi
    };
}());

app.tableResponsive = function () {
    if (matchMedia('(max-width: 767px)').matches) {
        if ($('.wysiwyg table').length) {

            var table = $('.wysiwyg table');
            table.addClass('table');
            table.attr('border', '0');
            table.attr('cellspacing', '0');
            table.attr('cellpadding', '0');
            table.width('100%');
            table.wrap('<div class="table-responsive"></div>');
        }
    }
};

app.modules.googleMap = (function () {
    function GoogleMap(element) {
        var self = this;
        this.element = $(element);
        this.canvas = element.find('.js-google-map__canvas')[0];
        this.mapInfo = element.find('.js-map-info');
        if (!this.mapInfo.length) {
            this.mapInfo = $('.js-map-info');
        }
        this.mapInfoAjaxAction = this.mapInfo.data('ajax-action');
        this.map = null;
        this.marker = [];
        this.geo = [];


        if (typeof $(this).data('infos') != 'undefined') {
            self.geo['longitude'] = $(this.canvas).data('longitude');
            self.geo['latitude'] = $(this.canvas).data('latitude');
        } else {
            self.geo['longitude'] = 80.6370814;
            self.geo['latitude'] = 47.3932376;
        }


        app.googleMap.loadApi(function () {
            self.initMap();
        });


        $.loadScript("/static/build/js/filterform.min.js").done(function () {
            if (matchMedia('(max-width: 767px)').matches) {
                $('.js-filter-form__hide-after-search-xs').show();
                $('.js-filter-form__show-after-search-xs').hide();

                $('#dealer-search__form').on('hidden.bs.collapse', function () {
                    $('html, body').stop().animate({
                            scrollTop: $('#dealerlist').offset().top
                        },
                        600,
                        'swing'
                    );
                });
            } else {
                $('.js-filter-form__hide-after-search').show();
                $('.js-filter-form__show-after-search').hide();
            }

            app.filterStore.subscribe(function () {
                var baseUrl = _config.filterStoreUrlMap,
                    address = $('.js-google-autocomplete').val();

                self.fetchMarker(baseUrl);

                // after loading new Markers the Tab should be initialized again (prevents rendering problems)
                self.initTab();

                if (matchMedia('(max-width: 767px)').matches) {
                    $('.js-filter-form__hide-after-search-xs').show();
                    $('.js-filter-form__show-after-search-xs').hide();

                    $('#dealer-search__form').collapse('hide');
                    $('.dealer-search__mobile-buttons').fadeIn();
                    $('#dealerlist').collapse('show');

                } else {
                    $('.js-filter-form__hide-after-search').hide();
                    $('.js-filter-form__show-after-search').show();
                }

                if (address) {
                    var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address;

                    $.ajax(url, {
                        cache: true,
                        dataType: 'json'
                    }).done(function (data, textStatus, jqXHR) {
                        self.getGeoLocation(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);

                    }).fail(function (response, errorType, errorText) {
                        console.error('Geolocation error', +response, errorType, errorText)
                    });
                }
            });
        });

    }

    GoogleMap.prototype.initMap = function () {
        var self = this;


        var mapOptions = {
            zoom: 12,
            center: new google.maps.LatLng(self.geo['latitude'], self.geo['longitude']),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            minZoom: 2,
            maxZoom: 17,
            disableDefaultUI: false,
            streetViewControl: false,
            mapTypeControl: false,
            scrollwheel: false,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "saturation": "21"
                        },
                        {
                            "lightness": "-4"
                        }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#2c2e33"
                        },
                        {
                            "saturation": 7
                        },
                        {
                            "lightness": 19
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#ffffff"
                        },
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": "-1"
                        },
                        {
                            "saturation": "-1"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#ffffff"
                        },
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 100
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#bbc0c4"
                        },
                        {
                            "saturation": -93
                        },
                        {
                            "lightness": 31
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "hue": "#bbc0c4"
                        },
                        {
                            "saturation": -93
                        },
                        {
                            "lightness": 31
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "hue": "#bbc0c4"
                        },
                        {
                            "saturation": -93
                        },
                        {
                            "lightness": -2
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#e9ebed"
                        },
                        {
                            "saturation": -90
                        },
                        {
                            "lightness": -8
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#e9ebed"
                        },
                        {
                            "saturation": 10
                        },
                        {
                            "lightness": 69
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#e9ebed"
                        },
                        {
                            "saturation": -78
                        },
                        {
                            "lightness": 67
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "saturation": "100"
                        },
                        {
                            "lightness": "39"
                        }
                    ]
                }
            ]
        };

        this.markerOptions = {
            current: {
                size: new google.maps.Size(60, 60),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(24, 24),
                scaledSize: new google.maps.Size(22, 22),
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#fff',
                    strokeColor: '#fff',
                    strokeWeight: 0,
                    fillOpacity: 0,
                    scale: 10
                }
            },
            poi: {
                size: new google.maps.Size(64, 94),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(20, 54),
                scaledSize: new google.maps.Size(32, 47),
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#fff',
                    strokeColor: '#fff',
                    strokeWeight: 0,
                    fillOpacity: 0,
                    scale: 10
                }
            }

        };

        self.map = new google.maps.Map(self.canvas, mapOptions);

        if (self.element.hasClass('js-google-map--poi')) {
            this.poiData = window[this.element.data('poi')];
            if (this.poiData) {
                this.setMarker(this.poiData);
            }
        }

        this.element.on('click', '.js-google-map__zoom-in', function () {
            self.map.setZoom(++self.map.zoom);
        });

        this.element.on('click', '.js-google-map__zoom-out', function () {
            self.map.setZoom(--self.map.zoom);
        });

        this.mapInfo.on('click', '.js-map-info__close', function () {
            self.closeMapInfo();
        });

        this.element.data('google-map', this);

        //if map is in accordion
        var accordion = this.element.closest('.collapse');
        if (accordion && accordion.length > 0) {
            accordion.one('shown.bs.collapse', function () {
                google.maps.event.trigger(self.map, 'resize');
                self.centerMap();
            });
        }


        //if map is in tab
        this.initTab();

        if (!this.element.hasClass('js-google-map--poi')) {
            this.typeahead();
        }

    };

    // checks if map is in a tab and repaints (by triggering resize) the map after changing to the corresponding tab
    GoogleMap.prototype.initTab = function () {
        var self = this,
            tabPanel = this.element.closest('.tab-pane');
        if (tabPanel && tabPanel.length > 0) {
            $('a[href="#' + tabPanel.attr('id') + '"]').one('shown.bs.tab', function () {
                google.maps.event.trigger(self.map, 'resize');
                self.centerMap();
            });
        }
    };

    GoogleMap.prototype.reloadMarker = function () {
        var self = this;
        for (var i = 0, marker; marker = self.marker[i]; i++) {
            marker.setMap(null);
        }

        // Reset the markers array
        this.marker = [];

    };


    GoogleMap.prototype.setMarker = function (data) {

        this.reloadMarker();
        var self = this;

        var disableClustering = false;
        if (self.element.hasClass('js-google-map--disable-clustering')) {
            var disableClustering = true;
        }

        //remove marker
        for (var i = 0, marker; marker = self.marker[i]; i++) {
            if (marker.dataId != 'myLocationMarker') {
                marker.setMap(null);
            }
        }

        self.marker = self.marker.filter(function (el) {
            return el.dataId == 'myLocationMarker';
        });


        $.loadScript('/static/build/js/libs/markerwithlabel_packed.js').done(function () {

            for (var i = 0, poi; poi = data[i]; i++) {
                if (poi.lat && poi.lng) {
                    var markerOptions;

                    if (poi.id == 'myLocationMarker') {
                        markerOptions = $.extend([], self.markerOptions['current'], {url: poi.poiIcon});
                    } else {
                        markerOptions = $.extend([], self.markerOptions['poi'], {url: poi.poiIcon});
                    }

                    var poiPosition = new google.maps.LatLng(poi.lat, poi.lng),
                        newMarker = new google.maps.Marker({
                                position: poiPosition,
                                map: self.map,
                                icon: markerOptions || self.markerOptions,
                                dataId: poi.id,
                                availableStepTwo: poi.availableStepTwo,
                                dataInfoBox: poi.infoBox,
                                smallInfoBox: poi.smallInfoBox,
                                defaultIcon: markerOptions || self.markerOptions,
                                label: {
                                    text: poi.poiLabel || ' ',
                                    color: '#54575a'
                                }
                            }
                        );

                    self.marker.push(newMarker);
                    self.centerMap(); //need for markerwithlabel

                    google.maps.event.addListener(newMarker, 'click', function () {
                        var isMarkerClick = true;
                        if (this.isActive) {
                            self.deactivateAllMarker();
                        } else {
                            self.deactivateAllMarker();
                            self.activateMarker(this.dataId, isMarkerClick);
                        }
                    });


                    (function (poi, newMarker) {
                        google.maps.event.addListener(newMarker, 'click', function () {
                            $.loadScript("/static/build/js/libs/google.maps.infobox.js").done(function () {
                                self.map.setCenter(newMarker.getPosition());
                                self.showDetail(poi.id, newMarker);
                            });
                        });

                        if (_config.googleMapShowInfoboxInitially && data.length === 1) {
                            $.loadScript("/static/build/js/libs/google.maps.infobox.js").done(function () {
                                self.map.setCenter(newMarker.getPosition());
                                self.showDetail(poi.id, newMarker);
                            });
                        }
                    }(poi, newMarker));

                    if (_config.marineversion) {
                        var clusterImg = "/static/build/img/map/cluster-marine.png";
                    } else {
                        var clusterImg = "/static/build/img/map/cluster.png";
                    }


                    if (!disableClustering) {

                        $.loadScript('/static/js/libs/markerclusterer_packed.js').done(function () {
                            var markerClusterOptions = {
                                styles: [{
                                    height: 70,
                                    url: clusterImg,
                                    width: 70,
                                    textSize: 24,
                                    textColor: "#ffffff",
                                    fontFamily: "Arial"
                                }]
                            };

                            if (self.markerCluster) {
                                self.markerCluster.clearMarkers();
                            }
                            var markerForCluster = [];

                            for (var i = 0, marker; marker = self.marker[i]; i++) {
                                if (marker.dataId != 'myLocationMarker') {
                                    markerForCluster.push(marker);
                                }
                            }
                            self.markerCluster = new MarkerClusterer(self.map, markerForCluster, markerClusterOptions);
                        });
                    }
                }
            }
        });
    };


    GoogleMap.prototype.fetchMarker = function (baseUrl) {
        var self = this,
            pendingRequest;

        if (pendingRequest) {
            pendingRequest.abort();
        }

        if (!baseUrl) {
            console.warn('GoogleMap.prototype.fetchMarker: baseUrl not defined');
            return true;
        }
        var url = baseUrl + (baseUrl.indexOf('?') < 0 ? '?' : '&') + $.param(app.filterStore.getSerializedParams());

        return pendingRequest = $.ajax(url, {
            cache: true,
            dataType: 'json',
            headers: {Ajax: 1, Format: 'json'}
        }).done(function (data, textStatus, jqXHR) {
            pendingRequest = null;
            self.setMarker(data);

            // update number of results
            $('.js-dealer-items-count').html(data.length);
        }).fail(function (response, errorType, errorText) {
            console.log(response, errorType, errorText)
        });
    };


    GoogleMap.prototype.centerMap = function () {
        google.maps.event.trigger(this.map, 'resize');
        var latlngs = [];


        for (var i = 0, marker; marker = this.marker[i]; i++) {
            latlngs.push(marker.getPosition());
        }

        // Zoom/center map to fit all marker
        if (latlngs.length === 1) {
            // customer wants to zoom out pretty far if only one marker is shown
            this.map.setZoom(7);
            this.map.setCenter(latlngs[0]);

        } else if (latlngs.length != 0) {

            var latlngbounds = new google.maps.LatLngBounds();

            if (this.element.attr('data-infos') == 'ROOFTOP') {
                latlngbounds.extend(latlngs[0]);
                latlngbounds.extend(latlngs[latlngs.length - 1]);
            } else {
                for (var i = 0, pos; pos = latlngs[i]; i++) {
                    latlngbounds.extend(pos);
                }
            }

            this.map.setCenter(latlngbounds.getCenter());
            this.map.fitBounds(latlngbounds);
        }
    };

    GoogleMap.prototype.zoomToMarker = function (marker) {
        this.map.setZoom(17);
        // centerMap to get right zoom
        // this.centerMap();
        // center map for the given marker
        this.map.setCenter(marker.getPosition());
    };

    GoogleMap.prototype.showDetail = function (id, marker) {
        var self = this;

        // if (this.detailView && this.detailView.markerId && this.detailView.markerId === id) {
        //     this.closeDetail();
        //     return;
        // }

        if (this.element.hasClass('js-google-map--poi')) {
            this.closeDetail();

            var detailContent = marker.dataInfoBox;

            var myOptions = {
                content: detailContent
                , pixelOffset: new google.maps.Size((matchMedia('(max-width: 767px)').matches ? -154 : -190), 10)
                , boxStyle: {
                    width: matchMedia('(max-width: 767px)').matches ? '300px' : '370px'
                }
                , boxClass: "infobox google-map__infobox"
                , closeBoxURL: "/static/build/img/map/google-map-close.png"
            };

            $.loadScript("/static/build/js/libs/google.maps.infobox.js").done(function () {
                self.detailView = new InfoBox(myOptions);
                self.detailView.open(self.map, marker);

                self.detailView.markerId = id;
            });
        } else {
            if (id != 'myLocationMarker') {
                this.closeDetail();

                var lang = _config.lang;
                var updatedLang = lang.replace("-", "_");

                var ajaxLang = _config.ajaxLangForTranslations;

                if(updatedLang != ajaxLang) {
                    updatedLang = ajaxLang;
                }

                var url="/dealersearch-get-dealer-poi-info?language=" + updatedLang + "&dealerid=" + id + '&availableStepTwo=' + marker.availableStepTwo;
                if (_config.marineversion) {
                    url +=  "&marineversion=true";
                }
                $.ajax({
                    method: "GET",
                    cache: true,
                    url: url
                }).done(function (msg) {
                    var detailContent = JSON.parse(msg).infoBox;
                    var myOptions = {
                        content: detailContent
                        , pixelOffset: new google.maps.Size((matchMedia('(max-width: 767px)').matches ? -154 : -190), 10)
                        , boxStyle: {
                            width: matchMedia('(max-width: 767px)').matches ? '300px' : '370px'
                        }
                        , boxClass: "infobox google-map__infobox"
                        , closeBoxURL: "/static/build/img/map/google-map-close.png"
                    };

                    $.loadScript("/static/build/js/libs/google.maps.infobox.js").done(function () {
                        self.detailView = new InfoBox(myOptions);
                        self.detailView.open(self.map, marker);

                        self.detailView.markerId = id;

                        if (_cfg.showDealerDetailLinks) {
                            self.detailView.addListener('domready', function () {
                                app.modules.showDealerDetailLinks($(self.detailView.div_));
                            });
                        }
                    });
                });
            }
        }

    };


    GoogleMap.prototype.closeDetail = function () {
        if (this.detailView && this.detailView.close) {
            this.detailView.close();
        }
        this.detailView = null;
    };

    GoogleMap.prototype.closeMapInfo = function () {
        this.element.removeClass('js-has-active-marker');
        this.mapInfo.addClass('hidden');
        this.deactivateAllMarker();
    };

    GoogleMap.prototype.deactivateAllMarker = function () {
        var self = this;
        self.activeMarker = null;

        for (var i = 0, marker; marker = self.marker[i]; i++) {
            marker.isActive = false;
            marker.labelClass = 'google-map__marker-wrapper';
            try {
                marker.label.setStyles(); //Force label to redraw (makes update visible)
            } catch (e) {
                // Ignore any exceptions
            }
        }

        $('.js-active-map').removeClass('is-active');
    };

    GoogleMap.prototype.zoomMarker = function () {
        this.map.setZoom(11);
        this.map.setCenter(this.activeMarker.getPosition());
    };

    GoogleMap.prototype.typeahead = function () {
        var start_input = document.getElementById('choose_city');
        var mapObj = this.map;
        var origin_autocomplete = new google.maps.places.Autocomplete(start_input);
        origin_autocomplete.bindTo('bounds', mapObj);

        $('.js-googlemap-typeahead').on('keydown change keyup', function (evt) {
            if ($(this).val().length <= 3) {
                evt.stopPropagation();
                evt.stopImmediatePropagation();
            }
        });
        origin_autocomplete.addListener('place_changed', function () {
            $('.js-googlemap-typeahead').triggerHandler("place_changed");
        });

    };

    GoogleMap.prototype.activateMarker = function (markerId, isMarkerClick) {

        var self = this,
            pendingRequest;
        self.deactivateAllMarker();

        for (var i = 0, marker; marker = self.marker[i]; i++) {
            if (marker.dataId == markerId) {
                var activeMarker = self.marker[i];
                this.activeMarker = activeMarker;

                activeMarker.isActive = true;
                activeMarker.labelClass = 'google-map__marker-wrapper' + ' is-active';


                try {
                    activeMarker.label.setStyles(); //Force label to redraw (makes update visible)
                } catch (e) {
                    // Ignore any exceptions
                }

                if (matchMedia('(max-width: 767px)').matches) {
                    $('#overlay-dealermap').addClass('is-open');
                } else {
                    // change tab
                    $('.js-map-tab').tab('show');

                }


                // show Infobox
                if (!isMarkerClick) {
                    self.showDetail(markerId, activeMarker);
                    //self.zoomToMarker(activeMarker);
                }


                // exit for loop, so other markers aren't checked
                break;
            } else {
                // last marker
                if (i == self.marker.length - 1) {
                    console.log('there is no marker with the given marker-id');
                }
            }
        }


    };

    function initScope($scope) {
        $scope.find('.js-google-map').each(function () {
            new GoogleMap($(this));
        });
    }

    return initScope;
}());

app.modules.showOnMapLinks = (function ($scope) {
    function initScope($scope) {

        var $gMap = $('.js-google-map').data('google-map');

        if ($gMap) {
            $scope.find('.js-show-on-map').on('click', function (e) {

                var markerId = $(this).data('poi-id');

                $('.js-map-tab').one('shown.bs.tab', function () {
                    $('.js-google-map').attr('data-infos', '');
                    $gMap.activateMarker(markerId);
                    $gMap.zoomMarker();
                });


                // change tab
                $('.js-map-tab').tab('show');


                e.preventDefault();

            });
        }

    }

    return initScope;
}());


app.modules.typeahead = function ($scope) {

    var $taInputs = $scope.find('.js-typeahead');
    $('.js-remove-all-filters').on('click', function (e) {
        app.filterStore.removeAllFilters();
        e.preventDefault();
    });

    if (!window.typeaheadData) {
        console.warn('No TypeaheadData is set. Typeahead not initialized.')
        return;
    }

    $.loadScript('/static/build/js/libs/typeahead.bundle.min.js').done(function () {
        $taInputs.each(function () {
            var $this = $(this);

            var typeAheadOptionsArray = [{
                hint: true,
                highlight: true,
                minLength: 1
            }];

            var bloodhound = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('text'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                local: typeaheadData
            });

            typeAheadOptionsArray.push({
                limit: Number.MAX_VALUE, /*workaround for https://github.com/twitter/typeahead.js/issues/1232*/
                display: 'text',
                source: bloodhound,
                templates: {
                    suggestion: function (data) {
                        var regexp = new RegExp(data._query, 'gi');
                        if (data.text) {
                            return '<div class="tt-suggestion tt-selectable small">' + data.text.replace(regexp, '<mark>$&</mark>') + '</div>';
                        }
                    }
                }
            });


            $this.typeahead.apply($this, typeAheadOptionsArray);

            $this.on('typeahead:open', function () {
                $('.filter-bar').addClass('filter-bar--typeahead-overlay');

            });

            $this.on('typeahead:close', function () {
                $('.filter-bar').removeClass('filter-bar--typeahead-overlay');
            });

            $(window).on('popstate', function (event) {
                console.log('pop', event.originalEvent);
                if (event.originalEvent.state && event.originalEvent.state.url) {
                    loadResult(event.originalEvent.state.url);
                }

            });


            $this.on('typeahead:select typeahead:autocompleted', function (typeaheadObj, data) {
                // when an entry is selected, the according url is used for the filter-form-result
                if ($this.hasClass('companyname')) {
                    loadResultCompanysearch(data.text, data.listUrl, data.mapUrl);
                } else {
                    if (data['url']) {
                        history.pushState({'url': data.url}, "title", data.url.replace('ajaxreload=true', ''));
                        loadResult(data.url);
                    }
                }

            });


            function loadResult(url) {
                console.log('loadResult');
                var $filterFormResultElements = $('');
                var pendingRequest;
                var $newfilterFormResultElements = $('.js-filter-form-result');
                $filterFormResultElements = $filterFormResultElements.add($newfilterFormResultElements);
                if (pendingRequest) {
                    pendingRequest.abort();
                }

                $filterFormResultElements.addClass('is-loading');
                $('.js-filter-form-loading').attr('hidden', false).removeClass('hidden');

                ///de/produkte/Ladekrane/Modelle?ajaxreload=true\u0026p_name=PC+900+Compact

                pendingRequest = $.ajax(url, {
                    cache: false,
                    dataType: 'html',
                    headers: {Ajax: 1}
                }).done(function (data, textStatus, jqXHR) {
                    pendingRequest = null;
                    setResults(data);

                }).fail(function () {
                    $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
                });


                function setResults(result) {
                    $filterFormResultElements.removeClass('is-loading');
                    $('.js-filter-form-loading').attr('hidden', true).addClass('hidden');
                    $filterFormResultElements.empty();
                    var $newContent = $(result);
                    $filterFormResultElements.append($newContent);
                    app.initModules($filterFormResultElements);
                }

            }

            function loadResultCompanysearch(formadata, listUrl, mapUrl) {
                ajaxCompanySearch(listUrl, mapUrl);
            }

        });
    });

};

app.modules.showDealerDetailLinks = (function ($scope) {
    function scrollToEl($el) {
        $('html, body').stop().animate({
                scrollTop: $el.offset().top - 50
            },
            600,
            'swing'
        );
    }

    function initScope($scope) {
        $scope.find('.js-dealersearchinteraction').on('click', function (evt) {
            const element = evt.target;
            const dealerName = $(element).attr('data-dealer-name');
            const dealerCountry = $(element).attr('data-dealer-country');
            const dealerRegion = $(element).attr('data-dealer-region');
            const dealerZip = $(element).attr('data-dealer-zip');
            const bpmid = $(element).attr('data-dealer-bpmid');
            var elementType = $(element).attr('data-dealer-type');
            var clickUrl = $(element).attr('href');
            var isCollapsed = $(element).hasClass('collapsed');
            var trackClick = true;

            if (elementType === 'phone') {
                elementType = 'phone link';
                clickUrl = clickUrl.replace('tel:', '');
            }
            if (elementType === 'email') {
                elementType = 'email link';
                clickUrl = clickUrl.replace('mailto:', '');
            }
            if (elementType === 'vcard') {
                elementType = 'business card link';
                clickUrl = 'https://palfinger.com' + clickUrl;
            }
            if (elementType === 'website') {
                elementType = 'website link';
            }
            if (elementType === 'directions') {
                elementType = 'directions link';
            }
            if (elementType === 'mapbutton') {
                elementType = 'show on map button';
                clickUrl = '';
            }
            if (elementType === 'accordion') {
                clickUrl = '';
                trackClick = isCollapsed;
            }

            if (window.dataLayer && trackClick) {
                window.dataLayer.push({
                    event: 'dealerSearchItemInteraction',
                    component: 'partner locator',
                    element: 'dealer search item',
                    elementName: '',
                    elementType: elementType,
                    clickUrl: clickUrl,
                    contentName: '',
                    position: '',
                    dealer: {
                        dealerName: dealerName,
                        dealerCountry: dealerCountry,
                        dealerRegion: dealerRegion,
                        dealerZip: dealerZip,
                        bpmid: bpmid
                    }
                });
            }
        });




        $('.js-list-tab').removeClass('scrolling');
        $scope.find('.js-show-dealer-detail, .js-show-on-map').on('click', function (e) {
            var self = $(this);
            var $container = $('.js-ajax__show-dealer-detail');
            var $result = $container.find('.js-ajax__show-dealer-detail__result');
            var $loading = $container.find('.js-ajax__show-dealer-detail__loading');
            var $error = $container.find('.js-ajax__show-dealer-detail__error');
            var pendingRequest = null;
            var dealerId = $(this).data('poi-id');
            var availableStepTwo = $(this).data('availablesteptwo');

            e.preventDefault();
            $result.attr('hidden', null);
            $loading.attr('hidden', null);
            // remove highlighted-class from already highlighted items
            $('.dealer-search-item.dealer-search-item--highlighted').removeClass('dealer-search-item--highlighted');

            var lang = _config.lang;
            var updatedLang = lang.replace("-", "_");

            var ajaxLang = _config.ajaxLangForTranslations;

            if(updatedLang != ajaxLang) {
                updatedLang = ajaxLang;
            }

            var url="/dealersearch-get-dealer-poi-info-detail?language=" + updatedLang + "&dealerid=" + dealerId + '&availableStepTwo=' + availableStepTwo;
            if (_config.marineversion) {
                url +=  "&marineversion=true";
            }

            if (pendingRequest) {
                pendingRequest.abort();
            }
            pendingRequest = $.ajax({
                method: "GET",
                cache: true,
                url: url
            }).done(function (msg) {
                $result.empty().append(msg);
                app.initModules($result);

                if (!self.is('.js-show-on-map')) {
                    scrollToEl($result);

                }


            }).fail(function (response, errorType, errorText) {
                if (textStatus !== 'abort') {
                    $error.attr('hidden', null);
                    console.error(textStatus, errorThrown, jqXHR);
                }

            }).always(function () {
                $loading.attr('hidden', 'hidden');
                pendingRequest = null;

            });

        });
    }

    return initScope;
}());


app.modules.watchlist = (function ($scope) {
    var request;

    function initInScope($scope) {

        setWatchListInfo($scope);

        $scope.find('.js-watchlist__btn').on('click', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();

            if ($(this).hasClass('is-added')) {
                $(this).removeClass('is-added');
                watchlistRemove($(this).data('watchlist-id'));
            } else {
                $(this).addClass('is-added');
                watchlistAdd($(this).data('watchlist-id'));
            }
        });
    }

    function getWatchlist() {
        var promise = $.Deferred();
        if (!supportsLocalStorage()) {
            console.error('Can\'t get watch list from local storage. Local storage is not supported.');
            return request = promise.reject(new Error('Can\'t get watch list from local storage. Local storage is not supported.'));
        }

        var newItemsById = {};
        var localStorageData = localStorage.getItem('watch-list');
        if (localStorageData) {
            newItemsById = JSON.parse(localStorageData);
        }

        return promise.resolve(newItemsById);
    }

    function addToWatchlist(ids) {
        var promise = $.Deferred();
        if (!supportsLocalStorage()) {
            console.error('Can\'t add item to local storage watch list. Local storage is not supported.');
            return promise.reject(new Error('Can\'t add item to local storage watch list. Local storage is not supported.'));
        }

        var itemsById = getItems();
        var newItemsById = $.extend({}, itemsById);

        ids.forEach(function (id) {
            newItemsById[id] = {};
        });

        setItems(newItemsById);
        return promise.resolve(newItemsById);
    }

    function removeFromWatchlist(idsToRemove) {
        var promise = $.Deferred();
        if (!supportsLocalStorage()) {
            console.error('Can\'t remove item to local storage watch list. Local storage is not supported.');
            return promise.reject(new Error('Can\'t remove item to local storage watch list. Local storage is not supported.'));
        }

        var itemsById = getItems();


        var newItemsById = Object.keys(itemsById).reduce(function (newItemsById, id) {
            idsToRemove.forEach(function (newId) {
                console.log(newId, id);

                if (newId != id) {
                    newItemsById[id] = itemsById[id];
                }
            });

            return newItemsById;
        }, {});


        setItems(newItemsById);
        return promise.resolve(newItemsById);
    }

    var $errorMessage = $('.js-watchlist__error');

    var itemsById = [];

    function setWatchListInfo($scope) {

        getWatchlist().then(function (data) {
            var $addButtons = $scope.find('.js-watchlist__btn');
            if ($addButtons && $addButtons.length) {
                var watchListItemsSelector = Object.keys(data).map(function (id) {
                    return '[data-watchlist-id="' + id + '"]';
                }).join(', ');

                $addButtons.filter(watchListItemsSelector).addClass('is-added');
            }
            setItems(data);
            // setWatchlistCount(getWatchListCount(), true);
        });
    }

    function watchlistAdd(ids) {
        if (!Array.isArray(ids)) {
            ids = [ids];
        }

        addToWatchlist(ids).then(function (data) {
            // setWatchlistCount(getWatchListCount(), true);

        }).catch(function (error) {
            $errorMessage.attr('hidden', null);
            console.error(error);
        });
    }

    function watchlistRemove(ids) {
        if (!Array.isArray(ids)) {
            ids = [ids];
        }
        removeFromWatchlist(ids).then(function (data) {
            // setWatchlistCount(getWatchListCount(), true);
        }).catch(function (error) {
            $errorMessage.attr('hidden', null);
            console.error(error);
        });
    }

    var callbacks = [];

    function getItems() {
        return itemsById;
    }

    // function getWatchlistIds() {
    //     if (!supportsLocalStorage()) {
    //         console.error('Can\'t get watch list from local storage. Local storage is not supported.');
    //     }
    //
    //     var newItemsById = [];
    //     var localStorageData = localStorage.getItem('watch-list');
    //     if (localStorageData) {
    //         newItemsById = JSON.parse(localStorageData);
    //     }
    //
    //     var ids = [];
    //     ids = Object.keys(newItemsById).map(function (id) {
    //         ids.push(id);
    //         return id;
    //     });
    //
    //     return ids;
    // }

    // function setWatchlistCount(count, animate) {
    //     if(count <= 0){
    //         $('.js-watchlist__count').text('0').closest('.js-watchlist__count-info').removeClass('has-items');
    //     }else {
    //         if(animate){
    //             $('.js-watchlist__count').text(count).closest('.js-watchlist__count-info').addClass('has-items is-animated');
    //             var t = setTimeout(function () {
    //                 $('.js-watchlist__count-info').removeClass('is-animated');
    //                 clearTimeout(t);
    //             }, 2000);
    //         }
    //
    //     }
    //     updateWatchlistCountParam();
    // }
    //
    // function updateWatchlistCountParam() {
    //     var dataIds = getWatchlistIds();
    //     var data = {
    //         "watchlist-ids": dataIds
    //     };
    //     var baseUrl = $('.js-watchlist__count-info').attr('href');
    //     baseUrl = baseUrl.split('?')[0];
    //     var url = baseUrl + (baseUrl.indexOf('?') < 0 ? '?': '&') + $.param(data);
    //     $('.js-watchlist__count-info').attr('href', url);
    // }

    function supportsLocalStorage() {
        var supports = false;
        try {
            localStorage.setItem('supportsLocalStorage', 'true');
            supports = !!localStorage.getItem('supportsLocalStorage')
        } catch (e) {
        }

        return supports;
    }

    function setItems(items) {
        items = items || {};
        itemsById = items;

        localStorage.setItem('watch-list', JSON.stringify(items));

        notifyListChangedCallbacks();
        return items;
    }

    function notifyListChangedCallbacks() {
        callbacks.forEach(function (callback) {
            callback(itemsById);
        });
    }

    function getWatchListCount() {
        return Object.keys(getItems()).length;
    }

    return initInScope;
}());


app.modules.toggleView = function ($scope) {
    $scope.find('.js-toggle-view__toggler').on('click', function (evt) {
        evt.preventDefault();

        var $parent = $scope.find('.js-toggle-view__toggler').closest('li');
        var $form = $scope.find('.js-toggle-view__form');

        var viewType = $(this).attr('data-view');
        var $filterInputs = $form.find('.js-toggle-view__input');
        var $filterInput = $form.find('.js-toggle-view__input[data-view=' + viewType + ']');

        if (!$(this).hasClass('active')) {
            $filterInputs.prop('checked', false);
            $filterInput.prop('checked', 'checked');

            $parent.removeClass('active');
            $(this).closest('li').addClass('active');
            $form.trigger('change');
        }
    });
};


app.modules.googleRecaptcha = function ($scope) {

    $scope.find('.formbuilder-form:not(.js-request-form__form)').on('submit', function (evt) {
        evt.preventDefault();

        var $form = $(this);

        if ($form.data('Parsley') && $form.data('Parsley').isValid() || !$form.data('Parsley')) {
            grecaptcha.ready(function () {
                grecaptcha.execute(_config.googleRecaptchasiteKey, {action: 'homepage'}).then(function (token) {
                    var $recaptchaResponseInput = $form.find('input[name="form\[googleRecaptcha\]"]');
                    $recaptchaResponseInput.val(token);

                    $form.unbind('submit').submit();
                });
            });
        }
    });
};

app.pageInfo = function () {
    var showPageInfo = sessionStorage.getItem('showPageInfo') || false;

    var pageInfo = $('.js-pageinfo'),
        closeBtn = $('.js-pageinfo__close');

    closeBtn.on('click', function (evt) {
        evt.preventDefault();
        pageInfo.addClass('hide');
        sessionStorage.setItem('showPageInfo', true);
        app.affixNavBar();
    });

    if (showPageInfo !== false) {
        pageInfo.addClass('hide');
    } else {
        pageInfo.removeClass('hide');
    }
};

app.calculatorAccessPlatforms = function () {

    $('.js-selectChanger').on('change', function (evt) {
        //set the value of the input to the selected calculation option
        //thereby we know which formula we need to use
        document.getElementById("calculation".concat(evt.target.id)).value = document.getElementById(evt.target.id).value;

        //show and hide the correct input for each operation
        if (document.getElementById(evt.target.id).value == "triptocycle") {
            document.getElementById("ctt-".concat(evt.target.id)).style.display = "none";
            document.getElementById("ttc-".concat(evt.target.id)).style.display = "block";
        } else {
            document.getElementById("ttc-".concat(evt.target.id)).style.display = "none";
            document.getElementById("ctt-".concat(evt.target.id)).style.display = "block";
        }
    })

    $('.js-doCalculation').on('click', function (evt) {
        //targetId tells us for which area the calculation needs to be done
        const targetId = evt.target.id;
        var solution = "";

        const capacity = document.getElementById("capacity".concat(targetId)).value;
        const cycle = document.getElementById("cycle".concat(targetId)).value;
        const consumption = document.getElementById("consumption".concat(targetId)).value;

        //check which calc the user selected
        if (document.getElementById("calculation".concat(evt.target.id)).value == "cycletotrip") {
            //check if theres input
            if (document.getElementById("cycle-ctt".concat(targetId)).validity.valid) {

                //calculate the solution and show it in the correct field
                const cycles = document.getElementById("cycle-ctt".concat(targetId)).value;
                document.getElementById("trip-solution-ctt".concat(targetId)).value = ((capacity - ((cycles * cycle) / 1000)) / (consumption / 1000)) / 2
            } else document.getElementById("trip-solution-ctt".concat(targetId)).value = "No Input (Cycle)";
        } else {
            if (document.getElementById("trip-ttc".concat(targetId)).validity.valid) {
                const trip = document.getElementById("trip-ttc".concat(targetId)).value;
                document.getElementById("cycle-solution-ttc".concat(targetId)).value = Math.round((capacity - (2 * trip * consumption) / 1000) / (cycle / 1000))
            } else document.getElementById("cycle-solution-ttc".concat(targetId)).value = "No Input (Trip)";

        }
    })

};

app.modules.triggerClickOnEl = function () {
    var $triggerClickOnEl = $('.js-trigger-click-on-el');

    $triggerClickOnEl.on('click', function (evt) {
        evt.preventDefault();
        var targetSelector = $(this).data('trigger-click-target') || $(this).attr('href');
        var $target = $(targetSelector);

        if ($target.length) {
            $target.first().click();
        }
    })
};

//todo
function disableBodyScroll() {
    var $body = $('body');
    $body.css({
        'overflow': 'hidden',
        'padding-right': window.innerWidth - $body.width() + 'px'
    });
}

function enableBodyScroll() {
    $('body').css({
        'overflow': '',
        'padding-right': ''
    });
}

app.initModules = function ($scope) {
    if (!$scope) {
        $scope = $('body');
    }

    if (_cfg['_preload']) {
        $.each(_cfg['_preload'], function (_key, _val) {
            if (_cfg['_preload'][_key] && app.modules[_key] && typeof window.app.modules[_key] == 'function') {
                cls.log('init module: ' + _key);
                window.app.modules[_key]($scope);
            }
        });
    }

    //init all modules if the right _cfg key is set for them
    for (var module in _cfg) {
        if (_cfg[module] && app.modules[module] && typeof app.modules[module] === 'function') {
            cls.log('init module: ' + module);
            app.modules[module]($scope);
        }
    }

    if (_cfg['_reload']) {
        $.each(_cfg['_reload'], function (_key, _val) {
            if (_cfg['_reload'][_key] && app.modules[_key] && typeof window.app.modules[_key] == 'function') {
                cls.log('init module ' + _key);
                window.app.modules[_key]($scope);
            }
        });
    }

};

(function ($) {
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_cfg['_preload']) {
        $.each(_cfg['_preload'], function (_key, _val) {
            if (typeof _val == 'boolean' && typeof window.app[_key] == 'function') {
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each(_cfg, function (_key, _val) {
        if ((typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload')) {
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_cfg['_reload']) {
        $.each(_cfg['_reload'], function (_key, _val) {
            if ((typeof _val == 'boolean' && typeof window.app[_key] == 'function')) {
                window.app[_key]();
            }
        });
    }

    app.initModules();

})(jQuery);
